/**
 * Tiếng Việt.
 *
 * Các khoá đến từ `cs.js`. Nếu thiếu khoá nào thì hiện chữ tiếng Anh (và nếu
 * cũng không có thì tiếng Séc), để chỗ trống dễ nhận ra.
 *
 * Bản dịch này chưa có người chuyển giới nói tiếng Việt đọc lại. Từ ngữ về
 * chuyển giới ở đây quan trọng hơn chỗ khác: nếu có gì nghe không đúng, hãy
 * báo và chúng tôi sẽ sửa.
 */
const vi = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Quay lại',
  'obecne.hledat': 'Tìm kiếm',
  'obecne.nacitani': 'Đang tải…',
  'obecne.zrusit': 'Huỷ',
  'obecne.ulozit': 'Lưu',
  'obecne.odeslat': 'Gửi',
  'obecne.vice': 'Xem tất cả',
  'obecne.jazyk': 'Ngôn ngữ',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'Một không gian an toàn cho cộng đồng chuyển giới, nơi bạn có thể nói thẳng, tìm sự giúp đỡ và cảm nhận sự ủng hộ của người khác.',
  'auth.prihlaseni': 'Đăng nhập',
  'auth.registrace': 'Đăng ký',
  'auth.email': 'Email',
  'auth.heslo': 'Mật khẩu',
  'auth.emailPriklad': 'ban@vidu.com',
  'auth.prihlasitSe': 'Đăng nhập',
  'auth.prihlasuji': 'Đang đăng nhập…',
  'auth.zapomenuteHeslo': 'Quên mật khẩu?',
  'auth.presGoogle': 'Đăng nhập bằng Google',
  'auth.spatneUdaje': 'Email hoặc mật khẩu không đúng',
  'auth.uspech': 'Đã đăng nhập.',
  'auth.googleChyba': 'Đăng nhập bằng Google không thành công',
  'auth.obnoveniHesla': 'Đặt lại mật khẩu',
  'auth.obnoveniOdeslano': 'Nếu email đã được đăng ký, bạn sẽ nhận được liên kết để đặt lại mật khẩu.',
  'auth.zpetNaPrihlaseni': 'Quay lại đăng nhập',
  'auth.odeslatOdkaz': 'Gửi liên kết',
  'auth.obnoveniChyba': 'Không gửi được email. Hãy thử lại.',

  // druhý krok přihlášení
  'auth.jesteKod': 'Còn một bước nữa: mã của bạn',
  'auth.jesteKodPopis': 'Mở ứng dụng xác thực và nhập sáu chữ số mà nó hiển thị cho Bloom.',
  'auth.kod': 'Mã',
  'auth.zalozniKodNapoveda': 'Không có điện thoại bên cạnh? Nhập một trong các mã dự phòng bạn đã lưu khi bật tính năng này.',
  'auth.potvrdit': 'Xác nhận',
  'auth.overuji': 'Đang kiểm tra…',
  'auth.kodNesedi': 'Mã này không đúng',
  'auth.zalozniDochazeji': (p) => `Bạn chỉ còn ${p.pocet} mã dự phòng. Hãy tạo mã mới trong hồ sơ.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'Cách cài Bloom trên điện thoại',
  'auth.krokyAndroid': [
      'Mở trang này trong Chrome',
      'Chạm vào biểu tượng ba chấm (⋮) ở góc trên bên phải',
      'Chọn „Thêm vào màn hình chính" hoặc „Cài đặt ứng dụng"',
      'Xác nhận cài đặt',
    ],
  'auth.krokyIos': [
      'Mở trang này trong Safari',
      'Chạm vào biểu tượng chia sẻ (□↑) ở thanh dưới',
      'Kéo xuống và chọn „Thêm vào MH chính"',
      'Xác nhận bằng „Thêm"',
    ],
  'auth.seznamChranene': [
      { silne: 'Không có gì về thành viên là công khai.', text: 'Hồ sơ, câu chuyện, lời mời giúp đỡ, câu hỏi, ảnh và avatar chỉ hiện ra với người đã đăng nhập. Không thể tải hay thu thập bất cứ thứ gì trong đó nếu không có tài khoản.' },
      { silne: 'Không ai biết mật khẩu của bạn', text: '— chúng tôi cũng không. Chỉ lưu một dấu vân bcrypt, từ đó không thể lấy lại mật khẩu gốc.' },
      { silne: 'Tin nhắn riêng và tệp đính kèm được mã hoá', text: '(AES + kiểm tra toàn vẹn) ngay trên ổ đĩa máy chủ. Ai lấy được bản sao lưu hay ổ đĩa cũng chỉ đọc thấy ký tự vô nghĩa.' },
      { silne: 'Tin nhắn tự xoá', text: 'sau một thời gian (mặc định 90 ngày), kể cả tin nhắn thoại và ảnh. Cái gì không còn ở đây thì không thể rò rỉ.' },
      { silne: 'Giai đoạn chuyển giới của bạn là riêng tư', text: 'cho đến khi chính bạn công khai nó. Những bước bạn đánh dấu trong Hướng dẫn chỉ mình bạn thấy.' },
      { silne: 'Email và số điện thoại', text: 'không bao giờ được hiển thị cho người khác.' },
      { silne: '', text: 'Việc đăng nhập được bảo vệ khỏi việc dò mật khẩu: số lần thử bị giới hạn.' },
      { silne: 'Mã hoá đầu cuối cho tin nhắn.', text: 'Khi bạn bật, phần chữ và tệp đính kèm được mã hoá ngay trong trình duyệt của bạn, còn máy chủ chỉ nhận được ký tự không đọc được. Khoá được mở bằng mật khẩu của bạn và không bao giờ rời khỏi thiết bị của bạn — nên chúng tôi cũng không đọc được nội dung, kể cả khi toà án yêu cầu. Cái giá là: nếu bạn quên mật khẩu, chính bạn cũng không đọc được tin nhắn cũ.' },
      { silne: '', text: 'Trạng thái đăng nhập không kéo dài mãi: Bloom đăng xuất khi bạn đóng cửa sổ và sau mười phút không hoạt động.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Siêu dữ liệu', text: '— ai viết cho ai và khi nào — máy chủ phải biết thì mới chuyển được tin nhắn. Mã hoá đầu cuối không giấu được điều đó, Signal cũng vậy.' },
      { silne: '', text: 'Bloom là ứng dụng web, nên mỗi lần mở nó lại tải mã mã hoá từ máy chủ của chúng tôi. Ai chiếm được máy chủ thì về lý thuyết có thể đưa ra mã đã bị sửa. Chỉ ứng dụng có chữ ký từ cửa hàng mới bảo vệ được — vì thế Signal có ứng dụng còn bản web thì không.' },
      { silne: 'Hồ sơ', text: '— biệt danh, mô tả, avatar — không thể mã hoá, vì máy chủ phải hiện chúng cho người khác.' },
      { silne: '', text: 'Tin nhắn từ trước khi bật mã hoá chỉ được mã hoá trên ổ đĩa máy chủ, không phải đầu cuối.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom chạy như một ứng dụng, kể cả khi không có mạng. Dữ liệu của bạn luôn được cập nhật.',
  'auth.zabezpeceniTitulek': 'Bloom được bảo vệ thế nào',
  'auth.zabezpeceniUvod': 'Bloom là không gian cho cộng đồng chuyển giới, nên ở đây gặp nhau những chuyện nhạy cảm. Dưới đây là những gì '
      + 'chúng tôi làm để bảo vệ chúng — và những gì chúng tôi không làm được — không tô vẽ.',
  'auth.coJeChranene': 'Những gì được bảo vệ',
  'auth.coNeumime': 'Những gì Bloom không làm được — và nói thẳng là đúng',
  'auth.zabezpeceniZaver': 'Nếu bạn có câu hỏi về quyền riêng tư hoặc tìm thấy lỗ hổng, hãy dùng „Báo lỗi" bên dưới. Chúng tôi coi trọng chuyện đó.',
  'auth.mvp': 'Bloom đang ở phiên bản đầu và chúng tôi cải thiện nó cùng cộng đồng. '
      + 'Nếu bạn gặp lỗi hay có ý tưởng, chúng tôi rất mong được biết.',
  'auth.nahlasitProblem': 'Báo lỗi',
  'auth.clenu': () => 'thành viên',
  'auth.prispevku': () => 'bài viết',
  'auth.odborniku': () => 'chuyên gia',
  'auth.nabidek': () => 'lời mời giúp đỡ',

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Biệt danh (không trùng)',
  'reg.prezdivkaPriklad': 'Ít nhất 3 ký tự',
  'reg.telefon': 'Điện thoại',
  'reg.volitelne': '(không bắt buộc)',
  'reg.heslo': 'Mật khẩu',
  'reg.hesloZnovu': 'Nhập lại mật khẩu',
  'reg.zajmeno': 'Đại từ',
  'reg.oMne': 'Về tôi',
  'reg.oMnePriklad': 'Vài dòng về bạn…',
  'reg.registrovat': 'Tạo tài khoản',
  'reg.registruji': 'Đang tạo tài khoản…',
  'reg.presGoogle': 'Đăng ký bằng Google',
  'reg.avatar': 'Avatar',
  'reg.neboFoto': 'Hoặc tải ảnh của riêng bạn',
  'reg.nahratFoto': 'Tải ảnh lên',
  'reg.vlastni': 'Ảnh riêng',
  'reg.zeme': 'Quốc gia',
  'reg.kraj': 'Vùng',
  'reg.nechciUvadet': 'Không muốn nói',
  'reg.cesko': 'Cộng hoà Séc',
  'reg.svet': 'Phần còn lại của thế giới',

  // skupiny avatarů
  'reg.avatarFem': 'Nữ tính',
  'reg.avatarMask': 'Nam tính',
  'reg.avatarNeutr': 'Trung tính',
  'reg.avatarZvirata': 'Động vật',

  // komunitní heslo
  'reg.komunitniHeslo': 'Mật khẩu cộng đồng',
  'reg.komunitniHesloPriklad': 'Nhập mật khẩu cộng đồng…',
  'reg.komunitniHesloPopis': 'Bloom là không gian riêng tư của cộng đồng chuyển giới. Ai đó trong cộng đồng có thể cho bạn mật khẩu.',
  'reg.napisAdminovi': 'Nếu bạn không quen ai, hãy viết cho ban quản trị tại',
  'reg.nevimHeslo': 'Tôi không biết mật khẩu cộng đồng',
  'reg.jakZiskat': 'Mật khẩu cộng đồng bảo vệ không gian riêng tư này. Cách lấy nó:',
  'reg.krok1': '1. Gửi email đến',
  'reg.krok2': '2. Giới thiệu ngắn gọn về bạn và cho biết bạn biết đến Bloom từ đâu',
  'reg.krok3': '3. Ban quản trị sẽ trả lời sớm nhất có thể',

  // kontrola hesla
  'reg.hesloKratke': 'Mật khẩu phải có ít nhất 8 ký tự',
  'reg.hesloMale': 'Mật khẩu phải có chữ thường',
  'reg.hesloVelke': 'Mật khẩu phải có chữ hoa',
  'reg.hesloCislo': 'Mật khẩu phải có chữ số',
  'reg.hesloZnak': 'Mật khẩu phải có ký tự đặc biệt (!@#$%…)',
  'reg.pozadavek8': 'Ít nhất 8 ký tự',
  'reg.pozadavekVelke': 'Chữ hoa',
  'reg.pozadavekCislo': 'Chữ số',
  'reg.pozadavekZnak': 'Ký tự đặc biệt (!@#$%)',
  'reg.hesloNesouhlasi': 'Hai mật khẩu không khớp',
  'reg.prezdivkaKratka': 'Biệt danh phải có ít nhất 3 ký tự',
  'reg.hesloPovinne': 'Bắt buộc phải có mật khẩu cộng đồng',
  'reg.hotovo': 'Đã tạo tài khoản. Hãy kiểm tra email để xác nhận.',
  'reg.fotoVelka': 'Ảnh quá lớn (tối đa 2 MB)',
  'reg.chyba': 'Không tạo được tài khoản',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Ở đây không ai phải hoàn hảo. Bloom là không gian nơi mỗi người có thể là chính mình — '
      + 'nơi bạn có thể chia sẻ trải nghiệm, đặt câu hỏi và giúp người khác. Không phán xét và không định kiến.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · dịch từ tiếng Séc',
  'domu.vitej': 'Chào,',
  'domu.vCislech': 'Bloom qua các con số',
  'domu.noveVKomunite': 'Lần đầu ở đây?',
  'domu.noveVKomunitePopis1': 'Bạn không phải để lộ mình. Bạn không cần ảnh. Bạn không phải công khai.',
  'domu.noveVKomunitePopis2': 'Bloom là không gian nơi bạn có thể bắt đầu theo nhịp của mình.',
  'domu.rozcestnik1': 'Tôi mới đến đây lần đầu',
  'domu.rozcestnik2': 'Tôi không biết bắt đầu từ đâu',
  'domu.rozcestnik3': 'Tôi muốn ẩn danh',
  'domu.rozcestnik4': 'Tôi tìm chuyên gia',
  'domu.rozcestnik5': 'Tôi chỉ muốn đọc trải nghiệm của người khác',
  'domu.otazky': 'Có câu hỏi hay muốn biết thêm? Hãy viết cho chúng tôi tại',
  'domu.doporucujeme': 'Gợi ý',
  'domu.odbornici': 'Chuyên gia',
  'domu.noviClenove': 'Người mới trong cộng đồng',
  'domu.zadniNovi': 'Chưa có ai mới',
  'domu.nejnovejsiOtazky': 'Câu hỏi mới nhất',
  'domu.zadneOtazky': 'Chưa có câu hỏi nào.',
  'domu.nejlepeHodnoceni': 'Chuyên gia được đánh giá cao nhất',
  'domu.zadniHodnoceni': 'Chưa có đánh giá nào',
  'domu.zadneAktuality': 'Chưa có tin tức nào',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Hãy mời giúp điều bạn làm được và nhận sự giúp đỡ từ người khác.',
  'domu.dlazdice.specialists': 'Tìm các chuyên gia đã được kiểm chứng, từ tâm lý đến phẫu thuật thẩm mỹ.',
  'domu.dlazdice.legal': 'Trợ giúp pháp lý, bài viết và câu trả lời cho câu hỏi của bạn.',
  'domu.dlazdice.nearby': 'Dịch vụ và chuyên gia gần bạn.',

  // počty
  'domu.pocetClenu': () => 'người trong cộng đồng',
  'domu.pocetZkusenosti': () => 'trải nghiệm được chia sẻ',
  'domu.pocetOdborniku': () => 'chuyên gia đã kiểm chứng',
  'domu.pocetNabidek': () => 'lời mời hỗ trợ',

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Trang chính',
  'nav.news': 'Tin tức',
  'nav.stories': 'Trải nghiệm của cộng đồng',
  'nav.mapaSveta': 'Bản đồ thế giới',
  'nav.support': 'Giúp đỡ lẫn nhau',
  'nav.specialists': 'Chuyên gia thân thiện với người chuyển giới',
  'nav.legal': 'Trợ giúp pháp lý',
  'nav.pageants': 'Cuộc thi',
  'nav.nearby': 'Gần tôi',
  'nav.hledat': 'Tìm trong Bloom',
  'nav.hledatPlaceholder': 'Tìm người, chuyên gia, bài viết…',
  'nav.zpravy': 'Tin nhắn',
  'nav.profil': 'Hồ sơ của tôi',
  'nav.mojeCesta': 'Hành trình của tôi',
  'nav.administrace': 'Quản trị',
  'nav.odhlasit': 'Đăng xuất',
  'nav.vsechnyVysledky': (p) => `Xem tất cả kết quả cho „${p.dotaz}"`,
  'nav.overEmail': 'Hãy xác nhận email',
  'nav.menu': 'Menu',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Bloom khắp thế giới',
  'svet.podtitulek': 'Chọn một quốc gia và xem cộng đồng đã gom được gì ở đó.',
  'svet.hledatZemi': 'Tìm quốc gia…',
  'svet.vsechnyZeme': 'Tất cả quốc gia',
  'svet.jenSObsahem': 'Chỉ quốc gia có nội dung',
  'svet.nicNenalezeno': 'Không có quốc gia nào khớp.',
  'svet.zaznamu': (p) => `${p.pocet} mục`,
  'svet.prazdnaZeme': 'Chưa có gì',
  'svet.kontinent': 'Châu lục',
  'svet.celySvet': 'Toàn thế giới',
  'svet.vse': 'Tất cả',
  'svet.zacniDomovem': 'Hãy bắt đầu bằng việc chọn quốc gia bạn coi là nhà. Bạn cũng có thể chọn trong danh sách dưới bản đồ.',
  'svet.zkoumej': 'Chọn một quốc gia và xem Bloom có gì ở đó. Bạn xem ở đâu cũng được — '
      + 'điều đó không đổi quốc gia của bạn.',
  'svet.domov': 'Nhà',
  'svet.zrusitDomov': 'Bỏ quốc gia cư trú',
  'svet.nastavitDomov': 'Đặt làm quốc gia của tôi',
  'svet.zeSveta': 'Từ khắp thế giới',
  'svet.coSeChysta': 'Sắp diễn ra',
  'svet.souteze': 'Cuộc thi đang mở đăng ký',
  'svet.noveOrganizace': 'Tổ chức mới',
  'svet.kdeJizNeco': 'Nơi Bloom đã có gì đó',
  'svet.hledatZemiPopisek': 'Tìm quốc gia',
  'svet.nicNeodpovida': 'Không có gì khớp. Hãy thử tìm cách khác.',
  'svet.napovedaKMape': 'Kéo bản đồ để di chuyển và phóng to bằng con lăn hoặc các nút. Bạn không '
      + 'bắt buộc phải dùng nó — ô tìm kiếm và danh sách đầy đủ các quốc gia ở bên dưới.',
  'svet.tvujBloom': (p) => `Bloom của bạn ở ${p.zeme}`,
  'svet.tvojeDomovska': 'quốc gia cư trú của bạn',
  'svet.zemi': (p) => `${p.pocet} quốc gia`,
  'svet.chyba': 'Không tải được danh sách quốc gia. Hãy tải lại trang.',
  'svet.pocet.specialists': (p) => `${p.pocet} chuyên gia`,
  'svet.pocet.organizations': (p) => `${p.pocet} tổ chức`,
  'svet.pocet.events': (p) => `${p.pocet} sự kiện`,
  'svet.pocet.pageants': (p) => `${p.pocet} cuộc thi`,
  'svet.pocet.resources': (p) => `${p.pocet} tài liệu`,

  // světadíly
  'kontinent.europe': 'Châu Âu',
  'kontinent.asia': 'Châu Á',
  'kontinent.africa': 'Châu Phi',
  'kontinent.north_america': 'Bắc Mỹ',
  'kontinent.south_america': 'Nam Mỹ',
  'kontinent.oceania': 'Châu Đại Dương',
  'kontinent.antarctica': 'Nam Cực',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Các cuộc thi dành cho người chuyển giới trên khắp thế giới. Những cuộc thi bạn còn kịp đăng ký nằm ở trên cùng.',
  'souteze.hledat': 'Tìm cuộc thi…',
  'souteze.zadne': 'Chúng tôi chưa có cuộc thi nào. Bạn biết cuộc thi nào không? Hãy gửi gợi ý.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `Mở: ${p.zeme}`,
  'nahled.zavrit': 'Đóng xem trước',
  'nahled.jenInformace': 'Hiện tại chúng tôi mới chỉ có thông tin về quốc gia này.',
  'nahled.zatimNic': 'Ở đây chúng tôi chưa có liên hệ, tổ chức hay sự kiện nào. Bạn biết gì đó? Hãy gửi gợi ý.',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom ở ${p.zeme}`,
  'zeme.podtitulek': (p) => `Những gì cộng đồng đã gom được ở ${p.zeme}.`,
  'zeme.prazdna': 'Bloom mới bắt đầu ở đây. Bạn có thể là người đầu tiên thêm gì đó.',
  'zeme.mapaSveta': 'Bản đồ thế giới',
  'zeme.navrhnout': 'Gợi ý một mục',
  'zeme.domovska': 'Quốc gia cư trú của bạn',
  'zeme.nastavitDomovskou': 'Đặt làm quốc gia của tôi',
  'zeme.kdeToJe': 'Tìm ở đâu',
  'zeme.coTuBude': 'Bạn sẽ tìm thấy gì ở đây',
  'zeme.zatimPrazdne': 'hiện đang trống',
  'zeme.pripravujeme': 'đang chuẩn bị',
  'zeme.zobrazitVse': (p) => `Xem tất cả (${p.pocet})`,
  'zeme.rosteTitulek': 'Bloom mới đang lớn lên ở đây',
  'zeme.rostePopis': 'Ở đây chúng tôi chưa có gì. Bạn biết một tổ chức, một sự kiện hay một '
      + 'liên hệ hữu ích? Hãy gửi gợi ý — nó sẽ qua kiểm duyệt rồi hiện ở đây.',
  'zeme.jinouZemi': 'Xem các quốc gia khác',
  'zeme.bezKontaktu': 'Ở đây chúng tôi chưa có liên hệ hay tổ chức nào.',
  'zeme.bezKontaktuPopis': 'Bạn biết ai đó hay điều gì hữu ích ở đây? Hãy gửi gợi ý — nó sẽ qua '
      + 'kiểm duyệt rồi hiện ở đây.',
  'zeme.neznama': 'Chúng tôi không biết quốc gia này.',
  'zeme.chyba': 'Không tải được quốc gia.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Phòng khám và bệnh viện',
  'sekce.specialists.popis': 'Bác sĩ, phòng khám và các chuyên gia khác mà cộng đồng có trải nghiệm.',
  'sekce.organizations': 'Tổ chức',
  'sekce.organizations.popis': 'Hội, tổ chức phi lợi nhuận và nhóm hỗ trợ.',
  'sekce.events': 'Sự kiện',
  'sekce.events.popis': 'Gặp mặt, Pride, workshop và hội thảo.',
  'sekce.pageants': 'Cuộc thi',
  'sekce.pageants.popis': 'Các cuộc thi dành cho người chuyển giới và lịch của chúng.',
  'sekce.resources': 'Tài liệu',
  'sekce.resources.popis': 'Thông tin thực tế về quốc gia này.',
  'sekce.community': 'Cộng đồng',
  'sekce.community.popis': 'Người và nhóm ở quốc gia này.',
  'sekce.legal': 'Trợ giúp pháp lý',
  'sekce.legal.popis': 'Thông tin và hỗ trợ cho cộng đồng chuyển giới',
  'sekce.support': 'Giúp đỡ lẫn nhau',
  'sekce.support.popis': 'Hãy mời giúp điều bạn làm được và nhận sự giúp đỡ từ những người khác trong cộng đồng',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'Tìm trong quốc gia này…',
  'vypis.vsechnyKategorie': 'Tất cả danh mục',
  'vypis.kategorie': 'Danh mục',
  'vypis.celaZeme': 'Cả nước',
  'vypis.navrhnout': 'Gợi ý',
  'vypis.nicNeodpovida': 'Không có gì khớp. Hãy thử tìm cách khác hoặc bỏ bộ lọc.',
  'vypis.zadneZaznamy': (p) => `Ở ${p.zeme} chúng tôi chưa có mục nào.`,
  'vypis.zaznamu': (p) => `${p.pocet} mục`,
  'vypis.predchozi': 'Trước',
  'vypis.dalsi': 'Tiếp',
  'vypis.chyba': 'Không tải được các mục.',
  'vypis.neznamyDruh': 'Chúng tôi không biết loại mục này.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Quay lại: ${p.zeme}`,
  'detail.kontakty': 'Liên hệ và liên kết',
  'detail.podrobnosti': 'Chi tiết',
  'detail.zacatek': 'Bắt đầu',
  'detail.termin': 'Ngày',
  'detail.uzaverka': 'Hạn đăng ký',
  'detail.prihlaska': 'Đăng ký',
  'detail.strankaAkce': 'Trang sự kiện',
  'detail.web': 'Trang web',
  'detail.konec': 'Kết thúc',
  'detail.stavRocniku': 'Tình trạng kỳ thi',
  'detail.oblasti': 'Lĩnh vực hoạt động',
  'detail.coNabizi': 'Họ cung cấp gì',
  'detail.kategorie': 'Danh mục',
  'detail.jazyky': 'Ngôn ngữ',
  'detail.vitezove': 'Người thắng các kỳ trước',
  'detail.kdoSeMuze': 'Ai có thể dự thi',
  'detail.poradatel': 'Đơn vị tổ chức',
  'detail.poplatek': 'Lệ phí',
  'detail.tema': 'Chủ đề',
  'detail.forma.offline': 'Trực tiếp',
  'detail.forma.online': 'Trực tuyến',
  'detail.forma.hybrid': 'Trực tiếp và trực tuyến',
  'detail.rozsah.local': 'Địa phương',
  'detail.rozsah.national': 'Toàn quốc',
  'detail.rozsah.international': 'Quốc tế',
  'detail.rocnik.upcoming': 'Sắp diễn ra',
  'detail.rocnik.registration_open': 'Đang mở đăng ký',
  'detail.rocnik.registration_closed': 'Đã đóng đăng ký',
  'detail.rocnik.completed': 'Đã diễn ra',
  'detail.zdroj': (p) => `Nguồn: ${p.zdroj}`,
  'detail.upraveno': (p) => `Cập nhật lần cuối: ${p.datum}`,
  'detail.overeno': 'Đã kiểm chứng là đúng thực tế. Đây không phải lời giới thiệu của Bloom.',
  'detail.neovereno': 'Mục này chưa được kiểm chứng. Thông tin có thể đã thay đổi — hãy đối chiếu với nguồn.',
  'detail.nenalezen': 'Chúng tôi không biết mục này. Có thể nó đã bị xoá hoặc còn đang chờ kiểm duyệt.',
  'detail.chyba': 'Không tải được mục này.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'Ở đây áp dụng gì',
  'profil.name_change': 'Đổi tên',
  'profil.gender_marker': 'Đổi giới tính trên giấy tờ',
  'profil.surgery_required': 'Có bắt buộc phẫu thuật không',
  'profil.healthcare': 'Tiếp cận chăm sóc y tế',
  'profil.legal_protection': 'Bảo vệ khỏi phân biệt đối xử',
  'profil.safety': 'An toàn',
  'profil.stav.yes': 'Có',
  'profil.stav.limited': 'Một phần',
  'profil.stav.no': 'Không',
  'profil.stav.unknown': 'Không có dữ liệu',
  'profil.zdroj': 'Nguồn',
  'profil.zdrojZRoku': (p) => `nguồn từ năm ${p.rok}`,
  'profil.overeno': (p) => `Đã kiểm ngày ${p.datum}`,
  'profil.zmena': 'Thay đổi gần đây',
  'profil.odKdy': (p) => `có hiệu lực từ ${p.datum}`,
  'profil.doklady': 'Nguồn',
  'profil.zakon': 'luật hoặc phán quyết',
  'profil.upozorneni': 'Đây không phải tư vấn pháp lý. Luật thay đổi và nhiều thứ phụ thuộc vào '
      + 'hoàn cảnh cụ thể của bạn — hãy đối chiếu với nguồn hoặc với một tổ chức ở '
      + 'quốc gia đó trước khi hành động.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `Gợi ý ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Gợi ý của bạn sẽ qua kiểm duyệt trước khi hiện trong Bloom. Hãy điền những gì '
      + 'bạn biết — phần còn lại chúng tôi bổ sung.',
  'navrh.jednotne.organizations': 'một tổ chức',
  'navrh.jednotne.events': 'một sự kiện',
  'navrh.jednotne.pageants': 'một cuộc thi',
  'navrh.jednotne.resources': 'một tài liệu',
  'navrh.popis.organizations': 'Một hội, một tổ chức phi lợi nhuận hoặc một nhóm hỗ trợ.',
  'navrh.popis.events': 'Một buổi gặp mặt, Pride, workshop, hội thảo.',
  'navrh.popis.pageants': 'Một cuộc thi dành cho người chuyển giới – ngày, đăng ký, đơn vị tổ chức.',
  'navrh.popis.resources': 'Thông tin thực tế – y tế, pháp luật, giấy tờ, liên hệ.',
  'navrh.nazev': 'Tên',
  'navrh.popisPole': 'Mô tả',
  'navrh.zeme': 'Quốc gia',
  'navrh.mesto': 'Thành phố',
  'navrh.adresa': 'Địa chỉ',
  'navrh.web': 'Trang web',
  'navrh.email': 'Email',
  'navrh.telefon': 'Điện thoại',
  'navrh.odkudVis': 'Bạn biết từ đâu',
  'navrh.odkudVisPriklad': 'ví dụ từ trang web của họ, tôi đã ở đó…',
  'navrh.vyberte': '— chọn —',
  'navrh.forma': 'Hình thức',
  'navrh.rozsah': 'Phạm vi',
  'navrh.platiPro': 'Áp dụng cho',
  'navrh.platnost.global': 'Toàn thế giới',
  'navrh.platnost.country': 'Một quốc gia',
  'navrh.platnost.region': 'Một vùng',
  'navrh.platnost.city': 'Một thành phố',
  'navrh.odkazAkce': 'Liên kết sự kiện',
  'navrh.odkazPrihlaska': 'Liên kết đăng ký',
  'navrh.odkazy': 'Liên kết',
  'navrh.text': 'Nội dung',
  'navrh.odeslat': 'Gửi gợi ý',
  'navrh.odesilam': 'Đang gửi…',
  'navrh.chyba': 'Không gửi được gợi ý',
  'navrh.dikyTitulek': 'Cảm ơn, chúng tôi đã nhận',
  'navrh.dikyPopis': 'Chúng tôi đã nhận gợi ý của bạn. Sẽ có người xem lại rồi nó hiện '
      + 'trong Bloom. Không có gì được đăng tự động.',
  'navrh.zavrit': 'Đóng',
  'navrh.seznamNapoveda': 'Ngăn cách các mục bằng dấu phẩy.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `${p.druh} này là của bạn?`,
  'prevzeti.popis': 'Bạn có thể nhận hồ sơ này và giữ cho thông tin luôn mới. '
      + 'Yêu cầu sẽ qua kiểm duyệt trước.',
  'prevzeti.tlacitko': 'Nhận hồ sơ này',
  'prevzeti.spravujes': 'Bạn quản lý hồ sơ này. Bạn có thể sửa thông tin bất cứ lúc nào — thay đổi có hiệu lực ngay.',
  'prevzeti.upravit': 'Sửa thông tin',
  'prevzeti.spravujeSama': (p) => `Hồ sơ này do chính ${p.druh} quản lý.`,
  'prevzeti.ceka': 'Chúng tôi đã nhận yêu cầu của bạn và đang xem xét.',
  'prevzeti.formulacTitulek': (p) => `Nhận hồ sơ — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Trước khi giao hồ sơ, chúng tôi cần biết bạn thật sự thuộc về tổ chức '
      + 'này. Yêu cầu sẽ qua kiểm duyệt; hiện chưa có gì thay đổi.',
  'prevzeti.role': 'Vai trò của bạn ở đó là gì?',
  'prevzeti.rolePriklad': 'ví dụ điều phối viên, chủ tịch hội',
  'prevzeti.doklad': 'Chúng tôi có thể kiểm chứng bằng cách nào?',
  'prevzeti.dokladPriklad': 'ví dụ tôi có tên trên trang liên hệ của tổ chức; hoặc hãy viết từ địa chỉ chính thức',
  'prevzeti.dokladNapoveda': 'Chỉ cần một liên kết tới trang có tên bạn, hoặc địa chỉ chính thức '
      + 'của tổ chức để bạn viết từ đó.',
  'prevzeti.kontakt': 'Liên hệ của bạn',
  'prevzeti.kontaktPriklad': 'email hoặc điện thoại',
  'prevzeti.dalsi': 'Còn gì nữa',
  'prevzeti.nepovinne': '(không bắt buộc)',
  'prevzeti.odeslat': 'Gửi yêu cầu',
  'prevzeti.odesilam': 'Đang gửi…',
  'prevzeti.vyplnObe': 'Hãy cho biết vai trò của bạn và cách kiểm chứng.',
  'prevzeti.prijato': 'Cảm ơn. Chúng tôi đã nhận yêu cầu và sẽ trả lời.',
  'prevzeti.chyba': 'Không gửi được yêu cầu.',
  'prevzeti.upravaTitulek': (p) => `Sửa hồ sơ — ${p.nazev}`,
  'prevzeti.upravaPopis': 'Tên và địa điểm cố ý không có ở đây: các mục được tìm và sắp xếp '
      + 'theo chúng. Nếu chúng đã đổi, hãy viết cho chúng tôi và chúng tôi sẽ cập nhật.',
  'prevzeti.popisPole': 'Mô tả',
  'prevzeti.email': 'Email',
  'prevzeti.telefon': 'Điện thoại',
  'prevzeti.web': 'Trang web',
  'prevzeti.ulozeno': 'Đã lưu.',
  'prevzeti.ukladam': 'Đang lưu…',
  'prevzeti.chybaUlozeni': 'Không lưu được.',
  'prevzeti.druh.organizations': 'tổ chức',
  'prevzeti.druh.events': 'sự kiện',
  'prevzeti.druh.pageants': 'cuộc thi',

  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'Sửa thông tin và cài đặt của bạn',
  'profil.overeny': 'Đã xác nhận',
  'profil.neovereny': 'Chưa xác nhận',
  'profil.overteEmail': 'Hãy xác nhận email của bạn. Tài khoản chưa xác nhận có quyền hạn chế.',
  'profil.emailOdeslan': 'Đã gửi email xác nhận.',
  'profil.emailChyba': 'Không gửi được email',
  'profil.odeslano': 'Đã gửi.',
  'profil.overeniOdbornika': 'Xác minh là chuyên gia hoặc luật sư',
  'profil.pracujeteVOboru': 'Bạn làm trong ngành? Hãy nhận huy hiệu xác minh.',
  'profil.zadostOdeslana': 'Đã gửi yêu cầu',
  'profil.pozadatOOvereni': 'Xin xác minh',
  'profil.zadostTitulek': 'Xin xác minh là chuyên gia hoặc luật sư',
  'profil.zadostPopis': 'Hãy điền thông tin yêu cầu. Ban kiểm duyệt sẽ xem xét.',
  'profil.pozadovanaRole': 'Vai trò xin xác minh',
  'profil.roleOdbornik': 'Chuyên gia',
  'profil.rolePravnik': 'Luật sư',
  'profil.specializace': 'Chuyên môn',
  'profil.odkazNaProfil': 'Liên kết tới hồ sơ nghề nghiệp',
  'profil.zpravaProAdmina': 'Một lời nhắn ngắn cho ban quản trị',
  'profil.odesilam': 'Đang gửi…',
  'profil.odeslatZadost': 'Gửi yêu cầu xác minh',
  'profil.vyplnteSpecializaci': 'Hãy điền chuyên môn của bạn',
  'profil.zadostUspech': 'Yêu cầu xác minh của bạn đã được gửi.',
  'profil.zadostChyba': 'Không gửi được yêu cầu',

  // bezpečnost
  'bezp.titulek': 'An toàn',
  'bezp.sifrovaniZapnuto': (p) => `Mã hoá tin nhắn đang bật${p.odemceno ? ' và đã mở khoá' : ' (bị khoá trong tab này)'}.`,
  'bezp.sifrovaniVypnuto': 'Bạn chưa bật mã hoá tin nhắn.',
  'bezp.sifrovaniKde': 'Bạn bật và mở khoá nó ở trang Tin nhắn.',
  'bezp.sifrovaniKdeVypnute': 'Bạn có thể bật ở trang Tin nhắn, trong bất kỳ cuộc trò chuyện nào.',
  'bezp.zmenaHesla': 'Đổi mật khẩu',
  'bezp.zmenaHeslaSifrovani': 'Bạn đang bật mã hoá, nên đổi mật khẩu cũng đóng gói lại khoá tin nhắn của bạn. '
      + 'Vì thế cần mật khẩu hiện tại — không có nó thì khoá không mở được và bạn sẽ mất tin nhắn.',
  'bezp.stavajiciHeslo': 'Mật khẩu hiện tại',
  'bezp.noveHeslo': 'Mật khẩu mới',
  'bezp.noveHesloZnovu': 'Nhập lại mật khẩu mới',
  'bezp.pozadavky': 'Ít nhất 8 ký tự, chữ hoa và chữ thường, một chữ số và một ký tự đặc biệt.',
  'bezp.zmenitHeslo': 'Đổi mật khẩu',
  'bezp.menim': 'Đang đổi…',
  'bezp.hesloNeshoda': 'Hai mật khẩu mới không khớp.',
  'bezp.vyplnObe': 'Hãy điền cả hai mật khẩu.',
  'bezp.stareNesedi': 'Mật khẩu hiện tại không đúng — khoá tin nhắn của bạn sẽ mất, nên chúng tôi không đổi gì.',
  'bezp.zmenenoSKlicem': 'Đã đổi mật khẩu. Khoá tin nhắn của bạn đã được đóng gói lại, nên tin nhắn cũ vẫn đọc được.',
  'bezp.zmeneno': 'Đã đổi mật khẩu.',
  'bezp.zmenaChyba': 'Không đổi được mật khẩu.',
  'bezp.nepamatujes': 'Không nhớ mật khẩu của khoá?',
  'bezp.zahoditPopis': 'Bạn có thể bỏ khoá và bắt đầu lại. Những tin nhắn đã mã hoá đến giờ sẽ mất vĩnh viễn — '
      + 'không ai đọc được, chúng tôi cũng không. Và chính vì thế nó mới an toàn.',
  'bezp.zahodit': 'Bỏ khoá và bắt đầu lại',
  'bezp.zahoditPotvrzeni': 'Thật sự bỏ khoá?\n\nTất cả tin nhắn đã mã hoá đến giờ sẽ mất vĩnh viễn — '
      + 'không ai đọc được, chúng tôi cũng không. Chỉ làm điều này khi bạn không nhớ mật khẩu '
      + 'đã dùng khi bật mã hoá.',
  'bezp.klicSmazan': 'Đã xoá khoá. Hãy tải lại trang.',
  'bezp.nepovedlo': 'Không thành công.',
  'bezp.prohlizecNeumi': 'Trình duyệt này không hỗ trợ kiểu mã hoá mà Bloom dùng.',

  'profil.mujProfil': 'Hồ sơ của tôi',
  'profil.specializacePriklad': 'ví dụ tâm lý, tình dục học, luật…',
  'profil.zpravaPriklad': 'Ví dụ liên kết tới giấy phép hành nghề hoặc trang phòng khám của bạn…',
  'profil.overeniUvod': 'Bạn muốn là chuyên gia hoặc luật sư đã xác minh trên Bloom? Hãy gửi yêu cầu xác minh. '
      + 'Hồ sơ của bạn phải khớp với nghề thật của bạn.',

  'profil.oborPriklad': 'ví dụ phẫu thuật thẩm mỹ, luật gia đình…',
  'profil.nepovinnyText': 'Ghi chú thêm, không bắt buộc…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Đăng nhập hai bước',
  'dvf.zapnuto': (p) => `Đang bật. Bạn còn ${p.pocet} mã dự phòng.`,
  'dvf.vypnuto': 'Ngoài mật khẩu, bạn còn nhập mã sáu chữ số từ một ứng dụng trên điện thoại.',
  'dvf.chraniA': 'Nó bảo vệ',
  'dvf.chraniPrihlaseni': 'việc đăng nhập',
  'dvf.chraniB': ': ai biết mật khẩu của bạn nhưng không có điện thoại của bạn thì không vào được.',
  'dvf.nechrani': 'Nó không bảo vệ tin nhắn đã mã hoá',
  'dvf.nechraniPopis': ' — những tin đó được mở bằng mật khẩu của bạn ngay trong trình duyệt, không qua máy chủ.',
  'dvf.ulozKody': 'Hãy lưu mười mã dự phòng này',
  'dvf.ulozKodyPopis1': 'Mỗi mã dùng được một lần, và đó là cách duy nhất để vào nếu bạn mất điện thoại.',
  'dvf.znovuNeukaze': 'Sẽ không ai cho bạn xem lại chúng',
  'dvf.ulozKodyPopis2': ' — chúng tôi chỉ lưu dấu vân của chúng.',
  'dvf.zkopirovat': 'Sao chép',
  'dvf.ulozilaJsem': 'Tôi đã lưu rồi',
  'dvf.zkopirovano': 'Đã sao chép.',
  'dvf.kopieChyba': 'Sao chép không được, hãy chép tay.',
  'dvf.zapnout': 'Bật đăng nhập hai bước',
  'dvf.pripravuji': 'Đang chuẩn bị…',
  'dvf.nactiKod': 'Quét mã này trong một ứng dụng xác thực — ví dụ Google Authenticator, Authy, 1Password hoặc Aegis.',
  'dvf.qrNejde': 'Không quét được mã QR?',
  'dvf.zadejRucne': 'Nhập khoá này vào ứng dụng bằng tay:',
  'dvf.opisKod': 'Nhập mã mà ứng dụng hiển thị',
  'dvf.zapnoutKratce': 'Bật',
  'dvf.overuji': 'Đang kiểm tra…',
  'dvf.noveKody': 'Mã dự phòng mới',
  'dvf.vypnout': 'Tắt',
  'dvf.noveKodyPopis': 'Bộ mã mới thay cho bộ cũ — các mã dự phòng hiện tại của bạn sẽ hết tác dụng.',
  'dvf.kodZAplikace': 'Mã từ ứng dụng',
  'dvf.vygenerovat': 'Tạo',
  'dvf.vypnutiPopis': 'Để tắt cần cả mật khẩu và một mã hợp lệ. Cả hai đều là cố ý: nếu không, bất cứ ai truy cập được trình duyệt đang mở cũng gỡ được.',
  'dvf.kodNeboZalozni': 'Mã từ ứng dụng hoặc mã dự phòng',
  'dvf.vypinam': 'Đang tắt…',
  'dvf.vypnoutCele': 'Tắt đăng nhập hai bước',
  'dvf.vypnuto2': 'Đã tắt đăng nhập hai bước.',
  'dvf.kodNesedi': 'Mã này không đúng.',
  'dvf.nepovedlo': 'Không thành công.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Đã cập nhật hồ sơ.',
  'pf.chyba': 'Không cập nhật được hồ sơ',
  'pf.fotkaNahrana': 'Đã tải ảnh lên.',
  'pf.fotkaChyba': 'Không tải được ảnh lên',
  'pf.fotkaVelka': 'Ảnh quá lớn (tối đa 5 MB)',
  'pf.oznameniUlozeno': 'Đã lưu cài đặt thông báo.',
  'pf.oznameniChyba': 'Không lưu được cài đặt',
  'pf.zruseno': 'Hồ sơ của bạn đã bị xoá',
  'pf.zruseniChyba': 'Không xoá được hồ sơ',
  'pf.zruseniPotvrzeni': 'Bạn thật sự muốn xoá hồ sơ? Việc này không hoàn tác được và mọi dữ liệu của bạn sẽ bị xoá.',
  'pf.urlFacebook': 'Địa chỉ Facebook phải bắt đầu bằng https://',
  'pf.urlInstagram': 'Địa chỉ Instagram phải bắt đầu bằng https://',
  'pf.urlLinkedin': 'Địa chỉ LinkedIn phải bắt đầu bằng https://',
  'pf.ukladam': 'Đang lưu…',
  'pf.ulozitOznameni': 'Lưu cài đặt thông báo',
  'pf.oznameniZpravy': 'Tin nhắn riêng',
  'pf.oznameniAdmin': 'Tin nhắn mới từ ban quản trị',
  'pf.oznameniUzivatel': 'Tin nhắn mới từ người khác',
  'pf.oznameniPodpora': 'Bài mới trong Giúp đỡ lẫn nhau',
  'pf.oznameniNabidky': 'Lời mời và lời nhờ',

  // odznaky
  'pf.odznakAdmin': 'Ban quản trị',
  'pf.odznakPravnik': 'Luật sư',
  'pf.odznakSpecialista': 'Chuyên gia đã xác minh',
  'pf.odznakClen': 'Thành viên đã xác minh',
  'pf.odznakPomocnik': 'Người giúp đỡ tích cực',
  'pf.odznakDuveryhodny': 'Người đáng tin',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Đã thêm ảnh vào thư viện.',
  'gal.smazano': 'Đã xoá ảnh',
  'gal.hesloKratke': 'Mật khẩu thư viện phải có ít nhất 4 ký tự',
  'gal.nahraniChyba': 'Không tải được ảnh lên',
  'gal.mazaniChyba': 'Không xoá được ảnh',
  'gal.souborVelky': 'Tệp quá lớn (tối đa 5 MB)',
  'gal.ulozitNastaveni': 'Lưu cài đặt',
  'gal.hesloPopis': 'Người xem sẽ phải nhập mật khẩu này để thấy thư viện.',
  'gal.pridat': 'Thêm ảnh hoặc video',
  'gal.prazdna': 'Thư viện chưa có ảnh nào',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'Tôi đang ở đâu?',
  'cesta.popis': 'Hãy chia sẻ giai đoạn chuyển giới của bạn nếu muốn — hoặc giữ cho riêng mình.',
  'cesta.soukroma': 'Giai đoạn của bạn là riêng tư',
  'cesta.viditelna': 'Người khác thấy được giai đoạn của bạn',
  'cesta.jenTy': 'Chỉ mình bạn thấy giai đoạn của mình',
  'cesta.mohouNajit': 'Người khác có thể tìm thấy bạn qua „Tìm người ở giai đoạn tương tự"',
  'cesta.poznamka': 'Ghi chú riêng',
  'cesta.volitelna': '(không bắt buộc)',
  'cesta.poznamkaPriklad': 'Bất cứ điều gì bạn muốn chia sẻ hay ghi nhớ…',
  'cesta.najitPodobne': 'Tìm người ở giai đoạn tương tự',
  'cesta.hledam': 'Đang tìm…',
  'cesta.ulozit': 'Lưu hành trình của tôi',
  'cesta.ulozeno': 'Đã lưu hành trình của bạn.',
  'cesta.vyberteFazi': 'Hãy chọn một giai đoạn',
  'cesta.chyba': 'Không lưu được',

  'pf.socialniSite': 'Mạng xã hội',
  'pf.avatarFoto': 'Avatar / ảnh hồ sơ',
  'pf.nahratProfilni': 'Tải ảnh hồ sơ lên',
  'pf.zrusitProfil': 'Xoá hồ sơ',
  'pf.nastaveniOznameni': 'Cài đặt thông báo',
  'pf.nastaveniOznameniPopis': 'Chọn những gì bạn muốn được báo.',
  'gal.overEmail': 'Để tải ảnh lên, trước hết hãy xác nhận email của bạn.',
  'cesta.coMeCeka': 'Điều gì đang chờ tôi',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Tin nhắn',
  'zpr.hledatUzivatele': 'Tìm người…',
  'zpr.zadneKonverzace': 'Chưa có cuộc trò chuyện nào',
  'zpr.vyhledejteVyse': 'Hãy tìm người ở phía trên',
  'zpr.vyberteKonverzaci': 'Chọn một cuộc trò chuyện hoặc tìm ai đó',
  'zpr.napisteZpravu': 'Viết tin nhắn…',
  'zpr.nahravam': 'Đang ghi âm…',
  'zpr.prilozitObrazek': 'Đính kèm ảnh',
  'zpr.hlasovaZprava': 'Tin nhắn thoại',
  'zpr.zastavitNahravani': 'Dừng ghi âm',
  'zpr.obrazek': 'Ảnh',
  'zpr.overteEmail': 'Để gửi tin nhắn, hãy xác nhận email của bạn.',
  'zpr.profil': 'Hồ sơ',

  // šifrování
  'zpr.sifrovanaZprava': 'Tin nhắn đã mã hoá',
  'zpr.odemkniNahore': 'Tin nhắn đã mã hoá — hãy mở khoá tin nhắn ở phía trên.',
  'zpr.nelzeOtevrit': 'Không mở được tin nhắn đã mã hoá này.',

  // hlášky
  'zpr.uzivatelNenalezen': 'Không tìm thấy người này',
  'zpr.prijemceNenalezen': 'Không tìm thấy người nhận',
  'zpr.prihlasteZnovu': 'Hãy đăng nhập lại (phiên đã hết hạn)',
  'zpr.serverNedostupny': 'Không tới được máy chủ. Hãy kiểm tra xem backend có chạy không.',
  'zpr.chybaOdeslani': 'Không gửi được',
  'zpr.souborVelky': 'Tệp quá lớn (tối đa 5 MB)',
  'zpr.formatNepodporovan': 'Loại tệp không được hỗ trợ',
  'zpr.mediaOdeslano': 'Đã gửi tệp',
  'zpr.mikrofon': 'Micro không dùng được',
  'zpr.hlasovkaOdeslana': 'Đã gửi tin nhắn thoại',
  'zpr.hlasovkaChyba': (p) => `Không gửi được tin nhắn thoại: ${p.detail}`,
  'zpr.smazano': 'Đã xoá cuộc trò chuyện',
  'zpr.smazaniChyba': 'Không xoá được cuộc trò chuyện',
  'zpr.smazaniPotvrzeni': 'Nó biến khỏi danh sách của bạn, cùng với tệp đính kèm. Người kia vẫn giữ bản của họ — '
      + 'tin nhắn chỉ bị xoá hẳn khỏi máy chủ khi cả hai cùng xoá.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Hãy nhập mật khẩu của bạn.',
  'sif.zapnuto': 'Mã hoá đang bật.',
  'sif.odemceno': 'Tin nhắn của bạn đã được mở khoá.',
  'sif.hesloNesedi': 'Mật khẩu này không đúng.',
  'sif.prohlizecNeumi': 'Trình duyệt này không hỗ trợ kiểu mã hoá mà Bloom dùng. Bạn vẫn viết được, '
      + 'nhưng tin nhắn sẽ không được mã hoá đầu cuối.',
  'sif.noveJsouSifrovane': 'Tin nhắn mới được mã hoá. Chỉ bạn giữ khoá — máy chủ không đọc được.',
  'sif.odemkniZpravy': 'Mở khoá tin nhắn của bạn',
  'sif.odemkniPopis': 'Khoá chỉ sống trong bộ nhớ của tab này, nên sau khi tải lại trang bạn cần nhập mật khẩu lần nữa. '
      + 'Chúng tôi không thể lưu nó ở đâu — khi đó nó sẽ không còn là mã hoá chỉ mình bạn kiểm soát.',
  'sif.zapniSifrovani': 'Bật mã hoá tin nhắn',
  'sif.zapniPopis': 'Tin nhắn mới được mã hoá ngay tại đây, trên thiết bị của bạn. Máy chủ chỉ nhận ký tự không đọc được '
      + 'và không đọc được chúng — kể cả khi toà án yêu cầu.',
  'sif.pozorA': 'Lưu ý: khoá được mở bằng mật khẩu của bạn.',
  'sif.pozorTucne': 'Nếu bạn quên nó, không ai đọc được tin nhắn đã mã hoá của bạn',
  'sif.pozorB': ' — chúng tôi cũng không. Đó chính là ý nghĩa, nhưng nghĩa là bạn cần một chỗ để giữ nó.',
  'sif.mobilA': 'Bật lên cũng đổi cách bạn đăng nhập: mật khẩu của bạn không còn tới máy chủ nữa, chỉ dấu vân của nó được gửi đi.',
  'sif.mobilTucne': 'Ứng dụng điện thoại Bloom bản cũ khi đó sẽ không đăng nhập được vào tài khoản này',
  'sif.mobilB': ' cho tới khi chúng tôi cập nhật nó. Trên web mọi thứ vẫn chạy bình thường.',
  'sif.zapnoutSifrovani': 'Bật mã hoá',
  'sif.odemknout': 'Mở khoá',
  'sif.tvojeHeslo': 'Mật khẩu Bloom của bạn',
  'sif.prilohaZamcena': 'Tệp đính kèm đã mã hoá — hãy mở khoá tin nhắn ở phía trên.',
  'sif.prilohaChyba': 'Không mở được tệp đính kèm.',
  'sif.priloha': 'Tệp đính kèm của tin nhắn',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Vị trí của bạn',
  'okoli.nastavtePolohu': 'Hãy cho biết bạn ở đâu để thấy kết quả phù hợp',
  'okoli.vyberteVyse': 'Chọn một địa điểm ở trên để thấy lời mời giúp đỡ và chuyên gia gần bạn',
  'okoli.zadniOdbornici': 'Khu vực này chưa có chuyên gia nào đăng ký',
  'okoli.zadneNabidky': 'Khu vực này chưa có lời mời nào',
  'okoli.zadniClenove': 'Khu vực này chưa có ai trong cộng đồng',
  'okoli.vytvoritNabidku': 'Tạo lời mời giúp đỡ',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Đang tìm:',
  'hled.vysledkyPro': 'Kết quả tìm kiếm:',
  'hled.nicPro': 'Chúng tôi không tìm thấy gì cho:',
  'hled.nicZkuste': 'Chúng tôi không tìm thấy gì. Hãy thử từ khác.',
  'hled.zkratte': 'Hãy thử cụm ngắn hơn hoặc từ khoá khác.',
  'hled.zadejte': 'Viết điều bạn tìm rồi nhấn Enter',
  'hled.priklady': 'Ví dụ: FFS, hormone, tên, bác sĩ, giấy tờ, phẫu thuật…',
  'hled.uzivatele': 'Người',
  'hled.odbornici': 'Chuyên gia thân thiện với người chuyển giới',
  'hled.clanky': 'Trợ giúp pháp lý – bài viết',
  'hled.otazky': 'Câu hỏi của cộng đồng',
  'hled.nabidky': 'Lời mời giúp đỡ',
  'hled.prispevky': 'Bài viết',
  'hled.recenze': 'Đánh giá về chuyên gia',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'Không tìm thấy người này',
  'up.oMne': 'Giới thiệu',
  'up.clenOd': 'Ở Bloom từ',
  'up.odznakSpravce': 'Ban quản trị',
  'up.odznakPravnik': 'Luật sư',
  'up.odznakOdbornik': 'Chuyên gia đã xác minh',
  'up.odznakPravnikOvereny': 'Luật sư đã xác minh',
  'up.odznakClen': 'Thành viên đã xác minh',
  'up.odznakPomocnik': 'Người giúp đỡ tích cực',
  'up.odznakDuveryhodny': 'Đáng tin',
  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Quay lại Bloom',
  'kom.oProjektu': 'Bloom ra đời như một không gian cộng đồng an toàn cho người chuyển giới ở Séc — một nơi '
      + 'để chia sẻ trải nghiệm, tìm sự ủng hộ, tiếp cận chuyên gia và làm quen với nhau. '
      + 'Dự án do chính cộng đồng vận hành, trên tinh thần tự nguyện. Mục tiêu là sự kín đáo, quyền riêng tư và giúp đỡ lẫn nhau.',
  'kom.kontaktText': 'Có câu hỏi hay cần giúp đỡ? Hãy liên hệ. Chúng tôi cố gắng trả lời sớm nhất có thể.',
  'kom.respekt': 'Chúng ta tôn trọng nhau',
  'kom.respektPopis': 'Chúng ta gọi mỗi người bằng tên và đại từ mà họ dùng. Chúng ta tôn trọng những con đường và trải nghiệm khác nhau — '
      + 'không có cách đúng hay sai để là người chuyển giới.',
  'kom.soukromi': 'Chúng ta giữ riêng tư cho nhau',
  'kom.soukromiPopis': 'Điều gì được chia sẻ trong Bloom thì ở lại Bloom. Đừng chia sẻ thông tin về người khác khi '
      + 'chưa có sự đồng ý của họ. Chúng ta tôn trọng sự ẩn danh.',
  'kom.pomahame': 'Chúng ta giúp nhau',
  'kom.pomahamePopis': 'Bloom là về hỗ trợ lẫn nhau. Chúng ta chia sẻ trải nghiệm, giúp nhau và dựng nên một không gian an toàn '
      + 'cho mọi người đang tìm kết nối hoặc thông tin.',
  'kom.obtezovani': 'Chúng tôi không dung thứ quấy rối',
  'kom.obtezovaniPopis': 'Quấy rối, bắt nạt hay bình luận thù địch không có chỗ trong Bloom. Nếu bạn thấy khó chịu, '
      + 'hãy viết cho ban quản trị.',
  'kom.spam': 'Không spam, không quảng cáo',
  'kom.spamPopis': 'Bloom không phải chợ. Đừng đăng quảng cáo không mời hay nội dung thương mại. '
      + 'Lời mời và lời nhờ thuộc về mục Giúp đỡ lẫn nhau.',
  'kom.prostor': 'Một không gian cho mọi giai đoạn',
  'kom.prostorPopis': 'Bạn không đơn độc, dù bạn đang ở đâu trên con đường của mình. Chúng tôi chào đón cả những người mới cân nhắc '
      + 'chuyển giới, những người đang trong quá trình và những người đã đi qua — và đón nhận mỗi con đường đúng như nó vốn có.',
  'kom.dataPopis': 'Bloom chỉ thu thập những dữ liệu mà nền tảng cần để chạy: email của bạn, biệt danh và hồ sơ '
      + 'do chính bạn tạo.',
  'kom.dataTretiStrany': 'Dữ liệu của bạn không được chia sẻ với bên thứ ba. Nền tảng không dùng công nghệ theo dõi hay mạng quảng cáo.',
  'kom.dataSmazani': 'Bạn có quyền yêu cầu xoá tài khoản và toàn bộ dữ liệu liên quan. Hãy liên hệ ban quản trị.',

  'okoli.podtitulek': 'Tìm người trong cộng đồng, dịch vụ và chuyên gia gần bạn',
  'okoli.cleneVOkoli': (p) => `Người trong cộng đồng gần ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Lời mời giúp đỡ gần ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Chuyên gia gần ${p.misto}`,
  'hled.zobrazitVice': 'Xem thêm',
  'kom.titulek': 'Nguyên tắc cộng đồng',
  'kom.podtitulek': 'Không gian an toàn cho tất cả mọi người',
  'kom.jakNahlasit': 'Cách báo cáo một vấn đề',
  'kom.jakNahlasitPopis': 'Nếu bạn gặp hành vi không phù hợp, bạn có hai cách: dùng nút „Báo cáo người này" '
      + 'trên hồ sơ của họ, hoặc viết cho ban quản trị.',
  'kom.duverne': 'Báo cáo của bạn được giữ kín.',
  'kom.ochranaSoukromi': 'Quyền riêng tư',
  'obecne.zpetKratce': 'Quay lại',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Hiện chưa có ai khác trong cộng đồng công khai giai đoạn này.',
  'cesta.poznamkaFazePriklad': 'Bất cứ điều gì bạn muốn chia sẻ hay ghi nhớ về giai đoạn này…',
  'pruvodce.fazeNenalezena': 'Không tìm thấy giai đoạn',
  'pruvodce.pripravujeme': 'Phần này chúng tôi còn đang chuẩn bị.',
  'pruvodce.krokyJenTy': 'Những bước bạn đánh dấu chỉ mình bạn thấy.',
  'pruvodce.nastavitFazi': 'Đặt làm giai đoạn hiện tại của tôi',
  'pruvodce.fazeNastavena': 'Đã đặt làm giai đoạn hiện tại của bạn',
  'pruvodce.chyba': 'Không lưu được, hãy thử lại',
  'pruvodce.kroku': 'bước',
  'pruvodce.odborniku': () => 'chuyên gia cho giai đoạn này',
  'pruvodce.pribehu': () => 'câu chuyện của người ở giai đoạn này',

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Đặt lại mật khẩu',
  'reset.popis': 'Hãy nhập mật khẩu mới cho tài khoản Bloom của bạn.',
  'reset.noveHeslo': 'Mật khẩu mới',
  'reset.noveHesloPriklad': 'Nhập mật khẩu mới',
  'reset.potvrdit': 'Xác nhận mật khẩu mới',
  'reset.nastavit': 'Lưu mật khẩu mới',
  'reset.ukladam': 'Đang lưu…',
  'reset.hotovo': 'Mật khẩu của bạn đã đổi. Bây giờ bạn có thể đăng nhập.',
  'reset.neplatnyOdkaz': 'Liên kết đặt lại mật khẩu này không hợp lệ.',
  'reset.odkazVyprsel': 'Liên kết đã hết hạn hoặc không hợp lệ. Hãy xin liên kết mới.',
  'reset.chyba': 'Không đặt lại được mật khẩu.',
  'reset.neshoda': 'Hai mật khẩu không khớp.',
  'reset.ztratiPristup': 'sẽ mất quyền truy cập',

  'cesta.volitelne': 'Việc này hoàn toàn tự nguyện. Hãy chia sẻ giai đoạn chuyển giới của bạn nếu muốn — hoặc giữ cho riêng mình. '
      + 'Bạn cũng có thể tìm những người đang ở chặng tương tự.',
  'cesta.hledatVeFazi': 'Tìm người ở giai đoạn này:',
  'cesta.jenVerejne': '(chỉ những người công khai điều đó)',
  'pruvodce.zpetNaCestu': 'Quay lại Hành trình của tôi',
  'pruvodce.tadyJsi': 'Bạn đang ở đây',
  'reset.prejitNaPrihlaseni': 'Đến trang đăng nhập',
  'reset.sifrovaniVarovani': 'Nếu bạn đang bật mã hoá tin nhắn: đặt lại mật khẩu nghĩa là bạn sẽ không còn tới được các tin nhắn '
      + 'đã mã hoá cũ. Khoá của chúng mở bằng mật khẩu ban đầu mà ở đây không ai biết, nên không đóng gói lại được. '
      + 'Tin nhắn mới vẫn mã hoá được; tin cũ thì không ai đọc được — kể cả chúng tôi.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'Đăng nhập',
  'uvod.vytvoritUcet': 'Tạo tài khoản',
  'uvod.uzMamUcet': 'Tôi đã có tài khoản',
  'uvod.nadpis': 'Không gian an toàn cho cộng đồng chuyển giới',
  'uvod.podnadpis': 'Bloom là nơi riêng tư để bạn nói thẳng, tìm được các chuyên gia thân thiện '
      + 'và đi qua quá trình chuyển giới giữa những người hiểu chuyện đó là thế nào.',
  'uvod.zdarma': 'Đăng ký miễn phí. Nội dung của Bloom chỉ mở ra sau khi đăng nhập.',
  'uvod.kCemuJe': 'Bloom để làm gì',
  'uvod.kCemuJe1': 'Tìm thông tin về chuyển giới ở Séc thường có nghĩa là bấm qua những diễn đàn '
      + 'rời rạc, những bài viết cũ và những đường dẫn mà bạn không biết nên tin ai. Mà nhiều câu hỏi '
      + 'thì người từng trải qua vẫn trả lời hay nhất.',
  'uvod.kCemuJe2': 'Bloom gom tất cả vào một chỗ: các chuyên gia mà cộng đồng có trải nghiệm tốt, một hướng dẫn '
      + 'qua từng giai đoạn chuyển giới, trợ giúp pháp lý, và trên hết là những người bạn có thể nhắn tin.',
  'uvod.kCemuJe3': 'Và vì đây là những chuyện không ai muốn kể cho cả internet, Bloom ngay từ '
      + 'đầu đã được dựng sao cho từ bên ngoài không nhìn thấy gì hết.',
  'uvod.coNajdes': 'Bạn sẽ tìm thấy gì trong Bloom',
  'uvod.coNajdesPopis': 'Tám phần nối tiếp nhau — từ giúp đỡ thực tế đến trải nghiệm được chia sẻ.',
  'uvod.soukromiZaklad': 'Quyền riêng tư không phải phần thêm, mà là nền tảng',
  'uvod.jakZabezpeceny': 'Bloom được bảo vệ thế nào',
  'uvod.zabezpeceniPopis': 'Dữ liệu của thành viên không được bán hay phân tích ở đâu cả. Trong Bloom không chạy bất kỳ '
      + 'công cụ theo dõi quảng cáo hay phân tích nào — không đoạn mã lạ nào biết được gì về bạn.',
  'uvod.coNeumi': 'Những gì Bloom không làm được',
  'uvod.metadataTucne': 'ai viết cho ai và khi nào',
  'uvod.coNeumiA': 'Máy chủ luôn biết',
  'uvod.coNeumiB': ' — không có điều đó thì nó không chuyển được tin nhắn. Mã hoá đầu cuối cũng không giấu được '
      + 'siêu dữ liệu này, Signal cũng vậy. Hồ sơ thì không mã hoá được, vì máy chủ phải hiện chúng cho người khác. '
      + 'Và vì Bloom là ứng dụng web, mỗi lần mở nó lại tải mã mã hoá từ máy chủ của chúng tôi — '
      + 'ai chiếm được máy chủ thì về lý thuyết có thể đưa ra bản đã sửa. '
      + 'Chỉ ứng dụng có chữ ký từ cửa hàng mới chống được điều đó.',
  'uvod.pridejSe': 'Tham gia cùng chúng tôi',
  'uvod.pridejSePopis': 'Chỉ cần một biệt danh và một email — bạn không phải khai tên thật ở bất cứ đâu. Bạn viết gì '
      + 'về mình là tuỳ bạn, và bạn có thể sửa hoặc xoá bất cứ lúc nào.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Hãy mời giúp hoặc nhờ giúp — từ đi cùng đến gặp bác sĩ, cho mượn quần áo, đến '
      + '„tôi cần nói chuyện với ai đó".',
  'uvod.karta.odbornici': 'Tình dục học, nội tiết, phẫu thuật, tâm lý trị liệu và cả tiệm tóc. Có bản đồ, liên hệ và trải nghiệm của người khác.',
  'uvod.karta.pravo': 'Đổi tên, giấy tờ, việc làm, trường học. Trả lời là những người hiểu chuyện.',
  'uvod.karta.pruvodce': 'Từng bước sẽ ra sao — từ những câu hỏi đầu tiên đến các ca phẫu thuật. Có liên kết tới nguồn đã kiểm chứng và chuyên gia.',
  'uvod.karta.zpravy': 'Nhắn cho bất kỳ ai trong cộng đồng. Tin nhắn và tệp đính kèm nằm trên máy chủ ở dạng đã mã hoá.',
  'uvod.karta.zkusenosti': 'Những câu chuyện thật của người đã đi qua. Không kiểm duyệt và không tô vẽ.',
  'uvod.karta.aktuality': 'Chuyện gì đang diễn ra quanh các chủ đề chuyển giới ở Séc — thay đổi luật, sự kiện, tin từ cộng đồng.',
  'uvod.karta.okoli': 'Ai đang ở gần bạn. Để bạn biết mình không đơn độc, kể cả ở thành phố nhỏ.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'Từ bên ngoài không nhìn thấy gì hết',
  'uvod.bezp.zvencinicText': 'Hồ sơ, câu chuyện, ảnh, lời mời và hình trong bài đều cần đăng nhập. Không có tài khoản thì '
      + 'máy chủ không đưa ra bất kỳ thông tin nào về thành viên — kể cả cho công cụ tìm kiếm.',
  'uvod.bezp.hesla': 'Không ai biết mật khẩu của bạn',
  'uvod.bezp.heslaText': 'Chỉ lưu một dấu vân bcrypt, từ đó không tính ngược ra mật khẩu gốc được. Ngay cả '
      + 'ban quản trị cũng không thấy mật khẩu của bạn và không gửi lại được — chỉ có thể cho bạn đặt mật khẩu mới.',
  'uvod.bezp.sifrovani': 'Tin nhắn được mã hoá từ bạn tới người kia',
  'uvod.bezp.sifrovaniText': 'Khi bạn bật mã hoá đầu cuối, phần chữ và tệp đính kèm được mã hoá ngay trong trình duyệt của bạn. '
      + 'Khoá được mở bằng mật khẩu của bạn và không bao giờ rời khỏi thiết bị — máy chủ chỉ nhận được '
      + 'ký tự vô nghĩa và không đọc được, kể cả khi toà án yêu cầu. Không bật mã hoá thì tin nhắn ít nhất vẫn '
      + 'được mã hoá trên ổ đĩa máy chủ.',
  'uvod.bezp.kontakty': 'Thông tin liên hệ vẫn là của bạn',
  'uvod.bezp.kontaktyText': 'Email và số điện thoại của bạn không bao giờ được trả về cho người khác. Giai đoạn chuyển giới của bạn là riêng tư cho đến khi '
      + 'chính bạn công khai — còn các bước bạn đánh dấu trong Hướng dẫn thì chỉ mình bạn thấy.',
  'uvod.bezp.smazane': 'Đã xoá là xoá thật',
  'uvod.bezp.smazaneText': 'Bạn có thể xoá một cuộc trò chuyện bất cứ lúc nào. Khi cả hai bên cùng xoá, nó biến khỏi máy chủ '
      + 'vĩnh viễn, cùng với tệp đính kèm.',
  'uvod.bezp.server': 'Máy chủ riêng ở châu Âu',
  'uvod.bezp.serverText': 'Bloom chạy trên máy chủ riêng trong Liên minh châu Âu, chỉ qua HTTPS. Cơ sở dữ liệu không truy cập được '
      + 'từ internet. Bản sao lưu được mã hoá và gửi sang nơi lưu trữ khác, việc khôi phục đã được thử.',

  'uvod.karta.pruvodceNazev': 'Hướng dẫn quá trình chuyển giới',
  'uvod.karta.zpravyNazev': 'Tin nhắn riêng',
  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Hãy mời giúp điều bạn làm được và nhận sự giúp đỡ từ những người khác trong cộng đồng',
  'pod.vse': 'Tất cả',
  'pod.nabidky': 'Lời mời',
  'pod.poptavky': 'Lời nhờ',
  'pod.nabidka': 'Lời mời',
  'pod.poptavka': 'Lời nhờ',
  'pod.celaCR': 'Toàn Séc',
  'pod.celySvet': 'Toàn thế giới',
  'pod.cesko': 'Séc',
  'pod.svet': 'Thế giới',
  'pod.vsechnyTypy': 'Tất cả danh mục',
  'pod.moje': (p) => `Của tôi (${p.pocet})`,
  'pod.pridat': 'Thêm',
  'pod.overEmail': 'Xác nhận email để thêm lời mời giúp đỡ',
  'pod.novaPoptavka': 'Lời nhờ mới',
  'pod.novaNabidka': 'Lời mời mới',
  'pod.popisPoptavky': 'Hãy viết bạn cần gì và bạn đưa lại được gì.',
  'pod.popisNabidky': 'Hãy mời điều bạn làm được cho những người khác trong cộng đồng.',
  'pod.typPrispevku': 'Loại bài',
  'pod.volitelne': '(không bắt buộc)',
  'pod.coNabizim': 'Tôi mời gì',
  'pod.coNabizimP': 'Tôi mời gì *',
  'pod.coHledamP': 'Tôi cần gì *',
  'pod.coHledamVymenou': 'Tôi cần gì đổi lại',
  'pod.priklOffer': 'ví dụ nấu ăn, làm tóc, dịch thuật…',
  'pod.priklNeed': 'ví dụ mát-xa, chụp ảnh…',
  'pod.poptavkaSeZobrazi': 'Lời nhờ của bạn sẽ hiện trong thẻ Lời nhờ.',
  'pod.nabidkaSeZobrazi': 'Nếu bạn điền, lời mời của bạn cũng sẽ hiện trong thẻ Lời nhờ.',
  'pod.popis': 'Mô tả',
  'pod.popisPriklad': 'Mô tả chi tiết hơn…',
  'pod.oblast': 'Khu vực',
  'pod.lokalita': 'Địa điểm',
  'pod.nechciUvadet': 'Không muốn nói',
  'pod.kategorie': 'Danh mục',
  'pod.ostatni': 'Khác',
  'pod.pridatPoptavku': 'Thêm lời nhờ',
  'pod.pridatNabidku': 'Thêm lời mời',
  'pod.odpovedetNaPrispevek': 'Trả lời bài viết',
  'pod.napisteAutorovi': 'Hãy nhắn riêng cho người đã đăng bài.',
  'pod.od': (p) => `Từ: ${p.kdo}`,
  'pod.odeslatZpravu': 'Gửi tin nhắn',
  'pod.konceptOdpovedi': (p) => `Chào bạn! Tôi quan tâm đến ${p.co} „${p.nazev}" của bạn. `,
  'pod.konceptPoptavka': 'lời nhờ',
  'pod.konceptNabidka': 'lời mời',
  'pod.zadneMoje': 'Bạn chưa có bài nào',
  'pod.zadneNalezeny': 'Không tìm thấy bài nào',
  'pod.vytvortePrvni': 'Hãy tạo lời mời hoặc lời nhờ đầu tiên của bạn',
  'pod.zkusteFiltry': 'Hãy thử đổi bộ lọc hoặc thêm bài mới',
  'pod.expirovano': 'Đã hết hạn',
  'pod.hledam': 'Tôi cần',
  'pod.hledamCo': (p) => `Tôi cần: ${p.co}`,
  'pod.nabizimCo': (p) => `Tôi mời: ${p.co}`,
  'pod.expirovala': 'Lời mời này đã hết hạn. Hãy viết cho ban quản trị để gia hạn.',
  'pod.odpovedet': 'Trả lời',
  'pod.upravitPrispevek': 'Sửa bài',
  'pod.upravtePrispevek': 'Sửa lời mời hoặc lời nhờ của bạn.',
  'pod.nabizimP': 'Tôi mời *',
  'pod.hledamPotrebuji': 'Tôi cần / tôi tìm',
  'pod.coNabizitePriklad': 'Bạn mời gì…',
  'pod.coHledatePriklad': 'Bạn cần gì…',
  'pod.ulozitZmeny': 'Lưu thay đổi',
  'pod.vytvorenoPoptavka': 'Đã tạo lời nhờ.',
  'pod.vytvorenoNabidka': 'Đã tạo lời mời.',
  'pod.chybaVytvorit': 'Không tạo được bài',
  'pod.opravduSmazat': 'Xoá lời mời này?',
  'pod.smazano': 'Đã xoá',
  'pod.chybaSmazat': 'Không xoá được',
  'pod.aktualizovano': 'Đã cập nhật bài.',
  'pod.chybaUlozit': 'Không lưu được',
  'pod.zpravaOdeslana': 'Đã gửi tin nhắn.',
  'pod.chybaOdeslat': 'Không gửi được tin nhắn',
  'obecne.hledatPriklad': 'Tìm kiếm…',
  'obecne.upravit': 'Sửa',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Tìm những chuyên gia đã được kiểm chứng có thể giúp bạn trên con đường của mình',
  'odb.hledatPriklad': 'Tìm theo tên hoặc thành phố…',
  'odb.vsechnyObory': 'Tất cả lĩnh vực',
  'odb.radit': 'Sắp xếp:',
  'odb.vychozi': 'Mặc định',
  'odb.nejvyssiHodnoceni': '★ Đánh giá cao nhất',
  'odb.nejnizsiHodnoceni': '★ Đánh giá thấp nhất',
  'odb.zadniNalezeni': 'Không tìm thấy chuyên gia nào',
  'odb.zkusteFiltry': 'Hãy thử đổi bộ lọc',
  'odb.recenzi': () => 'đánh giá',
  'odb.dostupnyV': 'Có mặt ở:',
  'odb.otevritVMapach': 'Mở trên bản đồ',
  'odb.pridatRecenzi': 'Thêm đánh giá',
  'odb.ohodnotte': 'Hãy đánh giá trải nghiệm của bạn với người này.',
  'odb.vaseHodnoceni': 'Đánh giá của bạn *',
  'odb.popisZkusenosti': 'Mô tả trải nghiệm của bạn',
  'odb.popisteZkusenost': 'Mô tả trải nghiệm của bạn…',
  'odb.odeslatRecenzi': 'Gửi đánh giá',
  'odb.recenze': (p) => `Đánh giá (${p.pocet})`,
  'odb.zadneRecenze': 'Chưa có đánh giá nào. Hãy là người đầu tiên.',
  'odb.vyberteOdbornika': 'Chọn một chuyên gia để xem chi tiết và bản đồ',
  'odb.pridatOdbornika': 'Thêm chuyên gia',
  'odb.pridejteOdbornika': 'Thêm vào danh sách một chuyên gia đã được kiểm chứng.',
  'odb.navrhnout': 'Gợi ý chuyên gia',
  'odb.navrhnetePopis': 'Gợi ý một chuyên gia để ban quản trị duyệt.',
  'odb.navrhVysvetleni': 'Gợi ý của bạn sẽ được gửi tới ban quản trị. Sau khi duyệt, nó sẽ hiện trong danh sách.',
  'odb.overEmail': 'Xác nhận email để gợi ý chuyên gia',
  'odb.jmeno': 'Tên *',
  'odb.kategorie': 'Danh mục *',
  'odb.popis': 'Mô tả',
  'odb.popisPriklad': 'Chuyên môn, kinh nghiệm…',
  'odb.adresa': 'Địa chỉ *',
  'odb.mesto': 'Thành phố *',
  'odb.kraj': 'Vùng',
  'odb.vyber': 'Chọn',
  'odb.stat': 'Quốc gia',
  'odb.cesko': 'Séc',
  'odb.telefon': 'Điện thoại',
  'odb.web': 'Trang web',
  'odb.odesilam': 'Đang gửi…',
  'odb.odeslatKeSchvaleni': 'Gửi để duyệt',
  'odb.recenzePridana': 'Đã thêm đánh giá.',
  'odb.chybaRecenze': 'Không thêm được đánh giá',
  'odb.odeslanKeSchvaleni': 'Gợi ý đã được gửi để duyệt.',
  'odb.chybaOdeslat': 'Không gửi được',
  'odb.pridan': 'Đã thêm chuyên gia.',
  'odb.chybaPridat': 'Không thêm được',
  'odb.polozitOtazku': 'Đặt câu hỏi',
  'odb.novaOtazka': 'Câu hỏi mới cho chuyên gia',
  'odb.naCoSeZeptat': 'Bạn muốn hỏi các chuyên gia điều gì?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Thông tin và hỗ trợ cho cộng đồng chuyển giới',
  'prav.zpetNaPoradnu': 'Quay lại Trợ giúp pháp lý',
  'prav.clankyAPruvodci': 'Bài viết và hướng dẫn',
  'prav.pridatClanek': 'Thêm bài viết',
  'prav.novyClanek': 'Bài viết mới',
  'prav.vytvorteClanek': 'Viết một bài mới cho phần pháp lý.',
  'prav.nazev': 'Tiêu đề *',
  'prav.kategorie': 'Danh mục',
  'prav.publikovatIhned': 'Đăng ngay',
  'prav.publikovano': 'Đã đăng',
  'prav.obsah': 'Nội dung *',
  'prav.obsahPriklad': 'Nội dung bài viết…',
  'prav.zadneClanky': 'Không có bài viết nào trong danh mục này',
  'prav.skryto': 'Đang ẩn',
  'prav.skryt': 'Ẩn',
  'prav.publikovat': 'Đăng',
  'prav.upravitClanek': 'Sửa bài viết',
  'prav.upravteObsah': 'Sửa nội dung bài viết này.',
  'prav.clanekPridan': 'Đã thêm bài viết.',
  'prav.chybaPridat': 'Không thêm được bài viết',
  'prav.clanekUpraven': 'Đã cập nhật bài viết.',
  'prav.opravduSmazat': 'Xoá bài viết này?',
  'prav.chybaStav': 'Không đổi được trạng thái',
  'prav.pridatOtazku': 'Thêm câu hỏi',
  'prav.novaOtazka': 'Câu hỏi mới',
  'prav.naCoSeZeptat': 'Bạn muốn hỏi gì?',
  'obecne.vse': 'Tất cả',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'Tin từ thế giới chuyển giới',
  'akt.prehratVideo': 'Phát video',
  'akt.obrazekVClanku': 'Ảnh trong bài',
  'akt.clanekNenalezen': 'Không tìm thấy bài viết',
  'akt.zpetNaAktuality': 'Quay lại tin tức',
  'akt.autor': (p) => `Tác giả: ${p.kdo}`,
  'akt.osobniPribeh': 'Câu chuyện cá nhân',
  'akt.upravitClanek': 'Sửa bài viết',
  'akt.komentare': (p) => `Bình luận (${p.pocet})`,
  'akt.zadneKomentare': 'Chưa có bình luận nào. Hãy là người đầu tiên.',
  'akt.pridatKomentar': 'Thêm bình luận…',
  'akt.proKomentovaniOverte': 'Xác nhận email để bình luận.',
  'akt.profil': 'Hồ sơ',
  'akt.prihlasteSeProKomentovani': 'Đăng nhập để bình luận.',
  'akt.upravteObsah': 'Sửa nội dung bài viết này.',
  'akt.nadpisP': 'Tiêu đề *',
  'akt.nadpis': 'Tiêu đề',
  'akt.obsahP': 'Nội dung *',
  'akt.textClanku': 'Nội dung bài…',
  'akt.obrazekUrlNeboSoubor': 'Ảnh (địa chỉ hoặc tệp)',
  'akt.videoUrlNeboSoubor': 'Video (địa chỉ hoặc tệp)',
  'akt.ukladam': 'Đang lưu…',
  'akt.novaAktualita': 'Tin mới',
  'akt.sdiletPribeh': 'Chia sẻ câu chuyện',
  'akt.vytvoritAktualitu': 'Viết tin',
  'akt.sdiletZkusenost': 'Chia sẻ trải nghiệm',
  'akt.napisteAktualitu': 'Viết một tin mới cho cộng đồng.',
  'akt.podelteSe': 'Hãy chia sẻ trải nghiệm của bạn với cộng đồng.',
  'akt.obrazek': 'Ảnh',
  'akt.nahratObrazek': 'Tải ảnh lên…',
  'akt.nahratVideo': 'Tải video lên…',
  'akt.neboUrl': 'hoặc địa chỉ:',
  'akt.textAktuality': 'Nội dung tin…',
  'akt.sdilejtePribeh': 'Hãy chia sẻ câu chuyện hay trải nghiệm của bạn với cộng đồng…',
  'akt.nahravam': 'Đang tải lên…',
  'akt.publikovat': 'Đăng',
  'akt.zkusenostiTucne': 'Trải nghiệm cá nhân của những người trong cộng đồng.',
  'akt.zkusenostiPopis': 'Phần này để chia sẻ trải nghiệm sống và câu chuyện. Bài viết có thể có chữ, ảnh hoặc video.',
  'akt.sdiletSvujPribeh': 'Chia sẻ câu chuyện của tôi',
  'akt.zadneAktuality': 'Không có tin nào',
  'akt.zadneVKategorii': 'Danh mục này hiện chưa có gì',
  'akt.publikovan': 'Đã đăng bài.',
  'akt.chybaPublikovat': 'Không đăng được',
  'akt.opravduSmazat': 'Xoá bài này?',
  'akt.chyba': 'Có gì đó không ổn',
  'akt.chybaKomentar': 'Không thêm được bình luận',
  'akt.chybaSmazatKomentar': 'Không xoá được bình luận',
  'akt.aktualizovan': 'Đã cập nhật bài.',
  'obecne.smazat': 'Xoá',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'Tôi đang nghĩ về chuyển giới',
  'faze.thinking.popis': 'Tôi đang tìm hiểu mình là ai và con đường nào là của mình.',
  'faze.research': 'Tôi đang tìm thông tin',
  'faze.research.popis': 'Tôi đọc, hỏi, tìm nguồn và tìm cộng đồng.',
  'faze.therapist': 'Lần đầu gặp nhà trị liệu',
  'faze.therapist.popis': 'Tôi nói về con đường của mình với một chuyên gia.',
  'faze.hormones': 'Liệu pháp hormone',
  'faze.hormones.popis': 'Tôi bắt đầu hoặc tiếp tục liệu pháp hormone.',
  'faze.documents': 'Đổi giấy tờ',
  'faze.documents.popis': 'Tôi đang lo việc đổi tên hoặc giới tính trên giấy tờ.',
  'faze.cosmetic': 'Ngoại hình và chăm sóc',
  'faze.cosmetic.popis': 'Tôi chăm cho ngoại hình của mình – tóc, trang điểm, phong cách.',
  'faze.surgery-thinking': 'Tôi đang cân nhắc phẫu thuật',
  'faze.surgery-thinking.popis': 'Tôi đang cân nhắc các lựa chọn phẫu thuật.',
  'faze.surgery': 'Sau phẫu thuật',
  'faze.surgery.popis': 'Tôi đã qua một hoặc nhiều ca phẫu thuật.',
  'faze.stable': 'Giai đoạn ổn định',
  'faze.stable.popis': 'Tôi đang ở nơi tôi muốn và sống cuộc đời của mình.',
  'faze.individual': 'Con đường riêng của tôi',
  'faze.individual.popis': 'Con đường của tôi không vừa cái khuôn nào – và thế cũng ổn.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'Đây là nơi mọi người chia sẻ câu chuyện.',
  'zk.pribehNenalezen': 'Không tìm thấy câu chuyện',
  'zk.zpetNaPribehy': 'Quay lại các câu chuyện',
  'zk.komunita': 'Cộng đồng',
  'zk.pribeh': 'Câu chuyện',
  'zk.upravitPribeh': 'Sửa câu chuyện',
  'zk.upravtePribeh': 'Sửa câu chuyện bạn đã chia sẻ.',
  'zk.textPribehu': 'Nội dung câu chuyện…',
  'zk.fazeTranzice': 'Giai đoạn chuyển giới',
  'zk.neuvadet': 'Không nói',
  'zk.ukazeSeLidem': 'Câu chuyện sẽ hiện với những người đang đọc hướng dẫn cho giai đoạn đó.',
  'zk.sdiletPribeh': 'Chia sẻ câu chuyện',
  'zk.overEmail': 'Xác nhận email để chia sẻ câu chuyện',
  'zk.zadnePribehy': 'Chưa có câu chuyện nào. Hãy là người đầu tiên.',
  'zk.nazevPribehu': 'Tiêu đề câu chuyện của bạn…',
  'zk.pribehP': 'Câu chuyện *',
  'zk.sdilejteZkusenost': 'Hãy chia sẻ trải nghiệm của bạn với cộng đồng…',
  'zk.chybaNacist': 'Không tải được các câu chuyện',
  'zk.vyplnteNadpis': 'Hãy điền tiêu đề và nội dung',
  'zk.spatnyOdkaz': 'Liên kết ảnh phải bắt đầu bằng http://, https:// hoặc /',
  'zk.sdilen': 'Đã chia sẻ câu chuyện.',
  'zk.chybaSdilet': 'Không chia sẻ được',
  'zk.opravduSmazat': 'Xoá câu chuyện này?',
  'zk.smazan': 'Đã xoá câu chuyện',
  'zk.aktualizovan': 'Đã cập nhật câu chuyện.',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'Email của bạn chưa được xác nhận. Hãy xác nhận nó.',
  'ram.odesilam': 'Đang gửi…',
  'ram.znovuOdeslat': 'Gửi lại',
  'ram.chceteUpozorneni': 'Bạn có muốn nhận thông báo về tin nhắn mới không?',
  'ram.tedNe': 'Để sau',
  'ram.paticka': '© 2026 Bloom – không gian riêng tư cho cộng đồng chuyển giới',
  'ram.zasadyKomunity': 'Nguyên tắc cộng đồng',
  'ram.prekladNeovereny': 'Bản dịch này chưa có ai nói ngôn ngữ này đọc lại. Nếu có gì nghe không đúng, hãy báo cho chúng tôi.',
  'ram.nahlasitProblem': 'Báo lỗi',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Ban quản trị',
  'ot.overenyPravnik': 'Luật sư đã xác minh',
  'ot.overenyOdbornik': 'Chuyên gia đã xác minh',
  'ot.odznakJinaZeme': (p) => `Huy hiệu này chỉ áp dụng cho: ${p.zeme}`,
  'ot.otazkyKomunity': 'Câu hỏi của cộng đồng',
  'ot.pridatOtazku': 'Thêm câu hỏi',
  'ot.novaOtazka': 'Câu hỏi mới',
  'ot.naCoSeZeptat': 'Bạn muốn hỏi gì?',
  'ot.otazkaSeZobrazi': 'Câu hỏi của bạn sẽ hiện với những người khác trong cộng đồng, họ có thể trả lời.',
  'ot.otazkaP': 'Câu hỏi *',
  'ot.oblastTema': 'Lĩnh vực / chủ đề',
  'ot.vseObecna': 'Bất cứ điều gì (câu hỏi chung)',
  'ot.odeslatOtazku': 'Gửi câu hỏi',
  'ot.overEmail': 'Xác nhận email để đặt câu hỏi',
  'ot.zadneOtazky': 'Chưa có câu hỏi nào. Hãy là người đầu tiên.',
  'ot.hlasu': () => 'lượt bình chọn',
  'ot.odpovedi': () => 'câu trả lời',
  'ot.zadneOdpovedi': 'Chưa có câu trả lời nào.',
  'ot.napisteOdpoved': 'Viết câu trả lời…',
  'ot.jenPravnici': 'Câu hỏi trong Trợ giúp pháp lý do luật sư đã xác minh và ban quản trị trả lời.',
  'ot.smazatOtazku': 'Xoá câu hỏi này?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Lời mời và lời nhờ',
  'cp.zadneNabidky': 'Không có lời mời nào',
  'cp.napsatZpravu': 'Nhắn tin',
  'cp.nahlasitUzivatele': 'Báo cáo người này',
  'cp.nahlasitKoho': (p) => `Báo cáo: ${p.kdo}`,
  'cp.popisteDuvod': 'Hãy nêu lý do bạn báo cáo. Ban quản trị sẽ thấy báo cáo.',
  'cp.zustaneteAnonymni': 'Báo cáo được gửi tới ban quản trị. Bạn vẫn ẩn danh.',
  'cp.duvodP': 'Lý do *',
  'cp.vybertDuvod': 'Chọn lý do…',
  'cp.nevhodneChovani': 'Hành vi không phù hợp',
  'cp.falesnyProfil': 'Hồ sơ giả',
  'cp.jinyProblem': 'Vấn đề khác',
  'cp.popisVolitelny': 'Mô tả',
  'cp.volitelny': '(không bắt buộc)',
  'cp.popisteSituaci': 'Hãy mô tả tình huống chi tiết hơn…',
  'cp.odeslatNahlaseni': 'Gửi báo cáo',
  'cp.vyberteDuvodChyba': 'Hãy chọn lý do báo cáo',
  'cp.nahlaseniOdeslano': 'Báo cáo đã được gửi tới ban quản trị',
  'cp.chybaNahlaseni': 'Không gửi được báo cáo',
  'gal.chranenoHeslem': 'Được bảo vệ bằng mật khẩu',
  'gal.soukromi': 'Riêng tư',
  'gal.nahravam': 'Đang tải lên…',
  'gal.pridatFotku': 'Thêm ảnh',
  'gal.nastaveniSoukromi': 'Quyền riêng tư của thư viện',
  'gal.verejna': 'Công khai',
  'gal.chranenaHeslem': 'Được bảo vệ bằng mật khẩu',
  'gal.nastaveniUlozeno': 'Đã lưu cài đặt thư viện',
  'gal.jeChranena': 'Thư viện này được bảo vệ bằng mật khẩu',
  'gal.zadneFotky': 'Chưa có ảnh nào. Hãy thêm ảnh đầu tiên.',
  'gal.otagovat': 'Gắn thẻ một người',
  'gal.hledatUzivatele': 'Tìm người…',
  'gal.odemcena': 'Đã mở khoá thư viện',
  'gal.spatneHeslo': 'Mật khẩu thư viện không đúng',
  'gal.fotkaNahrana': 'Đã tải ảnh lên.',
  'gal.chybaNahrat': 'Không tải được ảnh lên',
  'gal.fotkaSmazana': 'Đã xoá ảnh',
  'gal.jizOtagovan': 'Người này đã được gắn thẻ rồi',
  'gal.otagovan': (p) => `Đã gắn thẻ: ${p.kdo}`,
  'gal.chybaTag': 'Không thêm được thẻ',
  'gal.soukromiGalerie': 'Quyền riêng tư của thư viện',
  'gal.verejnaGalerie': 'Thư viện công khai',

  'ram.povolit': 'Cho phép',
  'ram.oProjektu': 'Về dự án',
  'ram.kontakt': 'Liên hệ',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'Bản đồ thế giới – bấm vào một quốc gia để mở',
  'mapa.priblizit': 'Phóng to',
  'mapa.oddalit': 'Thu nhỏ',
  'mapa.celySvet': 'Quay lại toàn thế giới',
  'mapa.chybaNacteni': 'Không tải được bản đồ',
  'mapa.chybaZkusteSeznam': 'Không tải được bản đồ. Hãy thử danh sách quốc gia bên dưới.',
  'mapa.teprveRoste': 'Bloom mới bắt đầu ở đây',
  'mapa.napovedaDotyk': 'Kéo để di chuyển bản đồ; phóng to bằng hai ngón, chạm hai lần hoặc dùng các nút. Bạn không nhất thiết phải dùng — bên dưới có ô tìm kiếm và danh sách đầy đủ các quốc gia.',
  'obsah.specialists': () => 'chuyên gia',
  'obsah.organizations': () => 'tổ chức',
  'obsah.events': () => 'sự kiện',
  'obsah.pageants': () => 'cuộc thi',
  'obsah.resources': () => 'tài liệu',
  'obsah.zaznamu': (p) => `${p.pocet} mục`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'Nhà của bạn ở đâu?',
  'domov.popis': 'Theo đó Bloom sẽ cho bạn thấy những gì ở gần. Bạn xem quốc gia nào cũng được — điều đó '
      + 'không đổi quốc gia cư trú của bạn. Nó không được công khai ở đâu cả và bạn đổi lúc nào cũng được.',
  'domov.preskocit': 'Bỏ qua',
  'domov.najitZemi': 'Tìm quốc gia…',
  'domov.nicNeodpovida': 'Không có gì khớp. Hãy thử tìm cách khác.',
  'domov.klikniDoMapy': 'Bạn cũng có thể bấm thẳng vào một quốc gia trên bản đồ phía trên.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'Bài viết',
  'typ.users': 'Người',
  'typ.specialists': 'Chuyên gia',
  'typ.services': 'Lời mời',
  'typ.articles': 'Trợ giúp pháp lý',
  'typ.questions': 'Câu hỏi của cộng đồng',
  'typ.reviews': 'Đánh giá về chuyên gia',
  'nav.emailNeoveren': 'Email chưa xác nhận',
  'nav.neovereny': 'Chưa xác nhận',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'Có gì đó không chạy',
  'chyba.navrh': 'Một ý tưởng cải thiện',
  'chyba.bezpecnost': 'Một vấn đề về an toàn',
  'chyba.jiny': 'Chuyện khác',
  'chyba.vyberteTyp': 'Hãy chọn loại vấn đề',
  'chyba.popisteProsim': 'Hãy mô tả vấn đề',
  'chyba.odeslano': 'Đã gửi báo cáo, cảm ơn bạn!',
  'chyba.chybaOdeslat': 'Không gửi được báo cáo',
  'chyba.napisteNam': 'Hãy kể cho chúng tôi chuyện gì đã xảy ra — điều đó giúp chúng tôi sửa.',
  'chyba.typProblemu': 'Loại vấn đề',
  'chyba.popisProblemu': 'Chuyện gì đã xảy ra',
  'chyba.popisPriklad': 'Hãy kể chuyện gì đã xảy ra, bạn mong đợi gì và thay vào đó đã xảy ra gì…',
  'chyba.priloha': 'Chúng tôi tự động kèm theo: trang hiện tại, thời gian và thông tin về trình duyệt của bạn.',
  'chyba.odeslatHlaseni': 'Gửi báo cáo',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Hãy viết nội dung…',
  'ed.tucne': 'In đậm (Ctrl+B)',
  'ed.kurziva': 'In nghiêng (Ctrl+I)',
  'ed.odrazky': 'Danh sách gạch đầu dòng',
  'ed.vlozitOdkaz': 'Chèn liên kết',
  'ed.vlozitTabulku': 'Chèn bảng',
  'ed.radky': 'Hàng',
  'ed.sloupce': 'Cột',
  'ed.vlozit': 'Chèn',
  'ed.barva.cerna': 'Đen',
  'ed.barva.seda': 'Xám',
  'ed.barva.fialova': 'Tím',
  'ed.barva.ruzova': 'Hồng',
  'ed.barva.modra': 'Xanh dương',
  'ed.barva.zelena': 'Xanh lá',
  'ed.barva.cervena': 'Đỏ',
  'ed.barva.oranzova': 'Cam',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'Liên kết xác nhận này không hợp lệ.',
  'over.hotovo': 'Email của bạn đã được xác nhận.',
  'over.odkazVyprsel': 'Liên kết xác nhận không hợp lệ hoặc đã hết hạn.',
  'over.overuji': 'Đang xác nhận email…',
  'over.cekejte': 'Hãy chờ một chút.',
  'over.overen': 'Đã xác nhận email.',
  'over.plnyPristup': 'Bây giờ bạn có toàn quyền dùng mọi thứ trong Bloom.',
  'over.prejitNaBloom': 'Vào Bloom',
  'over.selhalo': 'Xác nhận không thành công',
  'over.zpetNaPrihlaseni': 'Quay lại đăng nhập',
  'oauth.ucetNenalezen': 'Không tìm thấy tài khoản',
  'oauth.neexistujeGoogle': 'Không có tài khoản Bloom cho tài khoản Google này. Hãy đăng ký trước.',
  'oauth.neexistujeFacebook': 'Không có tài khoản Bloom cho tài khoản Facebook này. Hãy đăng ký trước.',
  'oauth.registrovatGoogle': 'Đăng ký bằng Google',
  'oauth.registrovatFacebook': 'Đăng ký bằng Facebook',
  'oauth.prihlasujiGoogle': 'Đang đăng nhập bằng Google…',
  'oauth.prihlasujiFacebook': 'Đang đăng nhập bằng Facebook…',
  'oauth.facebookSelhalo': 'Đăng nhập bằng Facebook không thành công',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Đang tải…',
  'obecne.nezadano': '— chưa nhập —',
  'obecne.neplatnaHodnota': 'Giá trị này không hợp lệ.',
  'obecne.strankovani': 'Phân trang',
  'navrh.doplnteNazev': 'Hãy điền tên.',
  'navrh.vyberteZemi': 'Hãy chọn quốc gia.',
  'navrh.doplnte': (p) => `Hãy điền: ${p.co}.`,
  'kat.overenoZaznam': 'Đã kiểm chứng rằng mục này đúng với thực tế',
  'kat.prihlaskyDo': (p) => `Đăng ký đến ${p.datum}`,

  'up.odznakAdmin': 'Quản trị',

  'profil.zalozkaProfil': 'Hồ sơ',
  'profil.zalozkaGalerie': 'Thư viện',
  'pf.lokalita': 'Địa điểm',

  'cesta.legendaBarev': 'Chú thích màu',

  'hled.pocetVysledku': (p) => `(${p.pocet} kết quả)`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Tóc vàng dài',
  'avatar.fem-lavender': 'Tóc tím',
  'avatar.fem-peach': 'Tóc bob có mái',
  'avatar.fem-dark': 'Tóc đen dài',
  'avatar.fem-straight': 'Tóc đỏ',
  'avatar.fem-ponytail': 'Tóc đuôi ngựa',
  'avatar.masc-blue': 'Tóc vàng ngắn',
  'avatar.masc-teal': 'Tóc rối',
  'avatar.masc-gray': 'Tóc bạc',
  'avatar.masc-short': 'Tóc đinh',
  'avatar.nb-mint': 'Tóc xanh bạc hà',
  'avatar.nb-lilac': 'Búi tóc cao',
  'avatar.nb-curly': 'Tóc xoăn ngắn',
  'avatar.nb-sage': 'Tóc ngang vai',
  'avatar.nb-mohawk': 'Tóc mohawk',
  'avatar.nb-undercut': 'Undercut',
  'avatar.nb-shaved': 'Đầu cạo',
  'avatar.nb-glasses': 'Kính',
  'avatar.animal-cat': 'Mèo',
  'avatar.animal-fox': 'Cáo',
  'avatar.animal-rabbit': 'Thỏ',
  'avatar.sym-flower': 'Hoa',
  'avatar.sym-butterfly': 'Bướm',
  'avatar.sym-star': 'Ngôi sao',
  'avatar.custom': 'Tải ảnh của riêng tôi',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'Chúng tôi đã đăng xuất bạn sau một lúc không hoạt động.',
  'odhl.necinnostPopis': 'Bloom không để phiên đăng nhập mở khi không có ai bên cạnh.',
  'odhl.zaChvili': 'Chúng tôi sắp đăng xuất bạn',
  'odhl.zaChviliPopis': 'Chạm vào màn hình hoặc bàn phím bất cứ lúc nào và bạn vẫn ở lại.',

  'reg.avatarSymboly': 'Biểu tượng',

  'avatar.fem-bun': 'Búi tóc',
  'avatar.masc-navy': 'Râu rậm',
  'avatar.masc-brown': 'Rẽ ngôi lệch',
  'avatar.masc-goatee': 'Râu dê',
  'avatar.nb-freckles': 'Tàn nhang',
  'avatar.animal-panda': 'Gấu trúc',
  'avatar.animal-owl': 'Cú',
  'avatar.sym-rainbow': 'Cầu vồng',
  'avatar.sym-heart': 'Trái tim',
  'avatar.sym-lotus': 'Hoa sen (Bloom)',

  'reg.potvrditHeslo': 'Xác nhận mật khẩu',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Tạo',
  'obecne.sdilet': 'Chia sẻ',
  'obecne.opravneni': 'Quyền truy cập',
  'obecne.pristupGalerie': 'Chúng tôi cần quyền truy cập thư viện ảnh để tải ảnh lên.',
  'obecne.vsechnyRegiony': 'Tất cả khu vực',
  'obecne.cesko': 'Séc',
  'obecne.odbornici': 'Chuyên gia',
  'obecne.zadnaZprava': 'Chưa có tin nhắn',
  'ucet.vyplnteEmailHeslo': 'Nhập e-mail và mật khẩu',
  'ucet.spatneUdaje': 'E-mail hoặc mật khẩu không đúng',
  'ucet.googleSelhalo': 'Đăng nhập bằng Google không thành công',
  'ucet.skrytHeslo': 'Ẩn mật khẩu',
  'ucet.emailOveren': 'E-mail của bạn đã được xác minh.',
  'ucet.emailPriklad': 'ban@email.com',
  'ucet.overeniSelhalo': 'Xác minh không thành công.',
  'ucet.overeniSelhaloZnovu': 'Xác minh không thành công. Vui lòng thử lại.',
  'ucet.komunitniHesloPovinne': 'Bắt buộc nhập mật khẩu cộng đồng',
  'ucet.zadejteKomunitniHeslo': 'Nhập mật khẩu cộng đồng…',
  'ucet.komunitniHesloPopis': 'Bloom là một không gian riêng tư. Ai đó trong cộng đồng có thể cho bạn mật khẩu.',
  'ucet.prezdivkaMin3': 'Tên hiển thị phải có ít nhất 3 ký tự',
  'ucet.vyplntePrezdivku': 'Nhập tên hiển thị',
  'ucet.vasePrezdivka': 'Tên hiển thị của bạn',
  'ucet.profilNeulozen': 'Không lưu được hồ sơ',
  'ucet.anoZrusitProfil': 'Có, xoá hồ sơ của tôi',
  'heslo.min8': 'Mật khẩu phải có ít nhất 8 ký tự',
  'heslo.maleP': 'Mật khẩu phải có chữ thường',
  'heslo.velkeP': 'Mật khẩu phải có chữ hoa',
  'heslo.cislo': 'Mật khẩu phải có chữ số',
  'heslo.specialni': 'Mật khẩu phải có ký tự đặc biệt',
  'heslo.specialniPriklad': 'Mật khẩu phải có ký tự đặc biệt (!@#$%)',
  'heslo.napoveda': 'Tối thiểu 8 ký tự, chữ hoa, số, ký tự đặc biệt',
  'profil.oSobe': 'Đôi lời về bạn…',
  'profil.zajmenaOna': 'cô ấy',
  'profil.zajmenaJine': 'khác',
  'profil.doplnujiciText': 'Ghi chú thêm (không bắt buộc)…',
  'profil.prikladOboru': 'ví dụ: phẫu thuật thẩm mỹ, luật gia đình…',
  'komunita.soukromiNadpis': 'Chúng tôi bảo vệ sự riêng tư',
  'komunita.soukromiText': 'Những gì được chia sẻ trong Bloom sẽ ở lại trong Bloom.',
  'komunita.podporaText': 'Bloom là nơi mọi người hỗ trợ lẫn nhau.',
  'komunita.neniObchod': 'Bloom không phải là sàn giao dịch.',
  'komunita.zadneObtezovani': 'Mọi hình thức quấy rối đều không có chỗ trong Bloom.',
  'komunita.oslovovani': 'Chúng tôi gọi mỗi người bằng tên và đại từ mà họ dùng.',
  'komunita.jakakolivEtapa': 'Dù bạn đang ở đâu trên hành trình của mình.',
  'prav.kategZdravi': 'Sức khoẻ',
  'prav.kategPravni': 'Pháp lý',
  'prav.kategSocialni': 'Xã hội',
  'ot.chybaOdpoved': 'Không gửi được câu trả lời.',
  'ot.chybaOtazka': 'Không đăng được câu hỏi.',
  'zk.napisteKomentar': 'Viết bình luận…',
  'zpr.chybaHlasova': 'Không tải lên được tin nhắn thoại. Máy chủ:',
  'zpr.chybaObrazek': 'Không tải lên được hình ảnh. Máy chủ:',
  'pod.nabizim': 'Tôi cung cấp',
  'pod.coHledate': 'Bạn đang tìm gì? (ví dụ: massage, chụp ảnh…)',
  'pod.coNabizite': 'Bạn cung cấp gì? (ví dụ: nấu ăn, làm tóc…)',
  'pod.lokalitaVolitelna': 'Địa điểm (không bắt buộc)',
  'pod.podrobnejsiPopis': 'Mô tả chi tiết hơn *',
  'pod.vyplnteHledate': 'Hãy cho biết bạn đang tìm gì.',
  'pod.vyplnteNabizite': 'Hãy cho biết bạn cung cấp gì.',
  'pod.vyplntePopis': 'Thêm mô tả.',
  'pod.zadnePrispevky': 'Bạn chưa có bài đăng nào. Hãy tạo một lời mời hoặc một yêu cầu.',
  'svet.vybratZemi': 'Chọn quốc gia',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Đặt câu hỏi',
  'ot.nadpis': 'Hỏi và đáp',
  'zk.pridat': 'Thêm câu chuyện',
  'zk.novy': 'Câu chuyện mới',
  'zk.smazat': 'Xoá câu chuyện',
  'zk.zadne': 'Chưa có câu chuyện nào. Hãy là người đầu tiên chia sẻ.',
  'akt.zadne': 'Chưa có tin mới.',
  'nav.clanky': 'Bài viết',
  'ucet.emailOdeslan': 'Đã gửi e-mail',
  'ucet.komunitniHeslo': 'Mật khẩu cộng đồng',
  'ucet.nemateUcet': 'Chưa có tài khoản? Đăng ký',
  'ucet.muzetePrihlasit': 'Bây giờ bạn có thể đăng nhập.',
  'ucet.zapomenutePopis': 'Nhập e-mail và chúng tôi sẽ gửi cho bạn liên kết đặt lại mật khẩu.',
  'profil.oMneVolitelne': 'Về tôi (không bắt buộc)',
  'profil.prezdivka': 'Tên hiển thị',
  'profil.telefonVolitelne': 'Điện thoại (không bắt buộc)',
  'cesta.poznamkaVolitelna': 'Ghi chú cá nhân (không bắt buộc)',
  'okoli.vyberteLokalitu': 'Chọn địa điểm ở trên',
  'hled.nadpis': 'Tìm kiếm',
  'hled.popis': 'Tìm trong toàn bộ ứng dụng – người dùng, bài viết, câu chuyện, đánh giá…',
  'hled.min2': 'Nhập ít nhất 2 ký tự để tìm kiếm',
  'pod.vsechnySluzby': 'Tất cả dịch vụ',
  'domu.clenoveKomunity': 'Thành viên cộng đồng',
  'zpr.zadneKonverzaceHledat': 'Chưa có cuộc trò chuyện nào. Hãy tìm ai đó ở trên.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'anh ấy',
  'reg.zajmenaOni': 'họ',
  'reg.zajmenaOno': 'người ấy',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Xoá ảnh',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Đặt mật khẩu cho thư viện',
  'reg.min3znaky': 'Tối thiểu 3 ký tự',
  'reg.zopakujteHeslo': 'Nhập lại mật khẩu',
  'hled.vBloom': 'Tìm trong Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'Chỉnh sửa hồ sơ',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Chọn khu vực',
  'obecne.region': 'Khu vực',
  'gal.heslemChranena': 'Được bảo vệ bằng mật khẩu',
  'gal.hesloGalerie': 'Mật khẩu thư viện',
  'reset.nastavitHeslo': 'Đặt mật khẩu',
  'reset.hesloObnoveno': 'Đã đặt lại mật khẩu.',
  'profil.nenalezen': 'Không tìm thấy hồ sơ',
  'obecne.nebo': 'hoặc',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Mở ứng dụng mã xác thực và nhập sáu chữ số hiển thị cho Bloom. Bạn cũng có thể dùng một mã dự phòng.',
  'auth.sifrovaniNapoveda': 'Nếu bạn đã bật mã hoá tin nhắn trên web, ứng dụng chưa thể đăng nhập vào tài khoản đó. Hãy dùng bloomapp.cz trên trình duyệt.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Hiện mật khẩu',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'Xoá ảnh này?',
  'dvf.zadejteKod': 'Nhập mã từ ứng dụng của bạn',
  'sif.odemknoutAplikaci': 'Mở khoá ứng dụng',
  'profil.odeslatZnovu': 'Gửi lại',
};

export default vi;
